import React, { Component } from 'react';
import {
  Text,
  View,
  TouchableHighlight,
  ActivityIndicator,
  Image,
  Dimensions,
  TextInput,
  Alert,
  Platform,
  Clipboard,
  ScrollView,
  Linking,
} from 'react-native';
import {StyleContext, styleInfo} from '../styleC';
import strings from '../strings';
import example from '../example';
import info from '../info';
import firebase from './firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, set, update, remove, get, onValue, child, orderByChild, orderByValue, limitToFirst, startAt, endAt, query} from "firebase/database";
import TextPresentation from './textPresentation';
import DeviceInfo from './deviceInfo'
import Modal from './modal';
const timer = require('react-native-timer');

import MavTextInput from './mavTextInput';
import MavButton from './mavButton';
import MavSelector from './mavSelector';
import MavQRCode from './mavQRCode';
import MavAlert from './mavAlert';
import moneyList from '../moneyList';
import MavViewMore from './mavViewMore';
import AddCreditCard from './addCreditCard';
import MavNavigationMinimize from './mavNavigationMinimize';
import { WebView } from 'react-native-webview';
import ManageOptions from './manageOptions';
import MavMiniButton from './mavMiniButton';
import RaceTrajetInfo from './raceTrajetInfo';
import KeyboardAwareScrollView from './keyboardAwareScrollView';


export default class book extends Component {
  constructor(props) {
    super(props);
    var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;           

    
    if(params.forceDriver==true) params.data.driver=true;
    
    var priceInfo=(params.data.priceEstimation=="" && params.data.priceEstimationTaxi=="")?"":(JSON.parse(JSON.stringify( (params.data.selected>params.data.priceEstimation.length-1)?params.data.priceEstimationTaxi[params.data.selected-params.data.priceEstimation.length]:params.data.priceEstimation[params.data.selected])))
    var priceInfoWithTrafic=(params.data.priceEstimation=="" && params.data.priceEstimationTaxi=="")?"":((params.data.selected>params.data.priceEstimationWithTrafic.length-1)?params.data.priceEstimationWithTraficTaxi[params.data.selected-params.data.priceEstimationWithTrafic.length]:params.data.priceEstimationWithTrafic[params.data.selected])
    var taxiMode=(priceInfo!="" && priceInfo.explicationPricing.taxiMode==true)?true:false;

    var estimatePriceGo=(priceInfo=="")?{realPrice:{priceTotal:0}}:((taxiMode==true)?JSON.parse(JSON.stringify(params.data.estimatePriceGoTaxi[params.data.selected -params.data.priceEstimation.length])) :JSON.parse(JSON.stringify(params.data.estimatePriceGo[params.data.selected])))
    if(taxiMode==true) priceInfo.name="TAXI - "+priceInfo.name


     
    var  optionalOrderArray=Object.keys(params.data.optionalOrder).sort((a,b)=>{ return params.data.optionalOrder[a].index-params.data.optionalOrder[b].index} )
    var availableOption=[]; 
    var availableListOption={};
    if(optionalOrderArray.length>0){
        var ioo;
        var test;
        for(ioo=0; ioo<optionalOrderArray.length;ioo++){
            test=params.data.optionalOrder[optionalOrderArray[ioo]];
            if (test.carList!=undefined && test.carList[priceInfo.name]==true){
              if(test.target==undefined || (params.data.vipMode==true && test.target.vip==true) || (params.data.customerPro==true && test.target.pro==true) || (params.data.vipMode!=true && params.data.customerPro!=true && test.target.standard==true)){
                  
                  availableListOption[optionalOrderArray[ioo]]=test;

                  availableOption.push({
                      name:((test.name[strings.idLangue]!=undefined)?test.name[strings.idLangue]:test.name["fr"]),
                      description:(test.description!=undefined)?(( test.description[strings.idLangue]!=undefined)?test.description[strings.idLangue]:test.description["fr"]):undefined,
                      quantityMax:test.quantity, 
                      pricePerUnit:((test.price!=undefined && test.price[params.data.money.id]!=undefined)?test.price[params.data.money.id]:0), 
                      quantity:0, 
                      price:0,

                  })
              }



            }
        }


    }



    /*
          estimatePriceWithTrafic:params.data.priceEstimationWithTrafic[params.data.selected].price,
        estimatePriceGo:JSON.parse(JSON.stringify(params.data.estimatePriceGo[params.data.selected])), 
    */



    var saveBook=(params.data.saveBook!=undefined)?params.data.saveBook:{name:"",lastName:"",phone:"",email:"",enterprise:"",adressBill:"",cityBill:"",description:"",passagersList:[]};
    
    console.log("params.data.stopList =")
    console.log(params.data.stopList)



    if(priceInfo.passagersMin!=undefined && priceInfo.passagersMin>saveBook.passagerNumber){
      saveBook.passagerNumber=priceInfo.passagersMin;
      if(saveBook.passagersList==undefined) saveBook.passagersList=[]
      if(saveBook.passagersList.length<(saveBook.passagerNumber-1)){
        var passi=saveBook.passagersList.length; 
        for(passi;passi<(saveBook.passagerNumber-1); passi++) saveBook.passagersList.push({name:"", lastName:"", phone:"", view:true}); 
        
      }
    }

 

    if(saveBook.trajetChange!=undefined && saveBook.trajetChange==true && saveBook.passagersList!=undefined && saveBook.passagersList.length>0){
      var savi;
      for(savi=0;savi<saveBook.passagersList.length;savi++){
          delete saveBook.passagersList[savi].start;
          delete saveBook.passagersList[savi].end;
      }
    }

    if(saveBook.passagerNumber==undefined) saveBook.passagerNumber=1; 
    if(saveBook.deferredPayment==undefined) saveBook.deferredPayment=false;
    if(saveBook.clientID==undefined) saveBook.clientID="";

   
    



    var trainFlightCoor;

    if(params.data.enableFlightTrainVerif==true){
      if(params.data.startTypeVerif=="train" || params.data.startTypeVerif=="flight" ) trainFlightCoor={latitude:params.data.stLat, longitude:params.data.stLng, type:"arrival"}
      if(params.data.destinationTypeVerif=="train" || params.data.destinationTypeVerif=="flight") trainFlightCoor={latitude:params.data.endLat, longitude:params.data.endLng, type:"departure"}
    }



    this.state = {
      params:params,
      trainFlightCoor:trainFlightCoor,
      forceManualDispatch:params.data.forceManualDispatch,
      unavailableIfRace:params.data.unavailableIfRace,
      purposeReturn:params.data.purposeReturn, 
      money:params.data.money,
      manager:params.data.manager,
      managerPhonebookOk:(params.data.managerInfo.phonebook==true)?true:false,
      kmLimit:"", 
      driver:(params.data.driver==true || (params.data.manager==true && params.data.managerInfo.dispatch==true) )?true:false,
      partner:params.data.partner,
      provider:params.data.provider,
      noVAT:params.data.noVAT,
      tvaNumber:params.data.tvaNumber, 
      privilegeProvider:params.data.privilegeProvider, 
      customerPro:params.data.customerPro,
      dispenser:params.data.dispenser.enabled,
      date: params.data.date,
      integerDate:params.data.integerDate,
      dateMin: params.data.dateMin ,
      description: saveBook.description,
      noCardDetected:false, 
      extraEUMode:(params.data.extraEUMode==true)?true:false, 
      selectedOptions:{},


      childSeats:false,
      childSeatsTxt:"",
      wheelchair:false,
      wheelchairTxt:"",
      animalTxt:"",
      boosterSeats:false,
      boosterSeatsTxt:"",
      wheelchair:false, 
      animal:false,


      
      forceDriverPrice:false,
      
      taxiMode:taxiMode, 
      alreadyPaid:false, 
      notBill:false,
      
      forceDriverPriceAmount:"",
      providerCommission:0,
      waiting:false,
      multipleCar:1,
      hideParticularRqs:params.data.hideParticularRqs,
      timeEstimation:params.data.timeEstimation,
      startAddress: params.data.startAddress,
      stopList:params.data.stopList,
      endAddress: params.data.endAddress,
      estimatePrice: priceInfo.price,
      estimatePriceWithTrafic:priceInfoWithTrafic.price,
      passagers:priceInfo.passagers,
      cpam:(priceInfo.cpam==true)?true:false,
      passagersMin:(priceInfo.passagersMin!=undefined)?priceInfo.passagersMin:1, 
      luggageMax:priceInfo.luggageMax,
      carName:priceInfo.name,
      estimateTime: params.data.timeEstimation,
      roomHotel:"",
      estimateKm: params.data.kmEstimation,
      coords:params.data.coords,
      companyBrand:info.companyBrand,
      companyAdress:info.companyAdress,
      companyCity:info.companyCity,
      companyPhone:info.companyPhone,
      companyEmail:info.companyEmail,
      estimatePromo:"",
      clientID:saveBook.clientID,
      promoCode:"",
      co2:(priceInfo.co2!=undefined)?priceInfo.co2:undefined, 
      addClientBook:params.data.addClientBook,
      passagerNumber:saveBook.passagerNumber,
      passagersList:(saveBook.passagersList!=undefined)?saveBook.passagersList:[],
      majoration:params.data.majoration,
      localMajoration:(priceInfo.majoration!=undefined)?priceInfo.majoration:{},
      promo:{},
      enterprise:(params.data.driver==false && params.data.manager==false && params.data.customerPro==false && params.data.partner==false && params.data.provider==false && params.data.enterprise!=undefined)?params.data.enterprise:saveBook.enterprise,
      adressBill:(params.data.driver==false && params.data.manager==false && params.data.customerPro==false && params.data.partner==false && params.data.provider==false && params.data.adressBill!=undefined)?params.data.adressBill:saveBook.adressBill,
      cityBill:(params.data.driver==false && params.data.manager==false && params.data.customerPro==false && params.data.partner==false && params.data.provider==false && params.data.cityBill!=undefined)?params.data.cityBill:saveBook.cityBill,
      
      name:(params.data.driver==false && params.data.manager==false && params.data.customerPro==false && params.data.partner==false && params.data.provider==false)?params.data.name:saveBook.name,
      lastName:(params.data.driver==false && params.data.manager==false && params.data.customerPro==false && params.data.partner==false && params.data.provider==false)?params.data.lastName:saveBook.lastName,
      phone:(params.data.driver==false && params.data.manager==false && params.data.customerPro==false && params.data.partner==false && params.data.provider==false)?params.data.phone:saveBook.phone,
      email:(params.data.driver==false && params.data.manager==false && params.data.customerPro==false && params.data.partner==false && params.data.provider==false)?params.data.email:saveBook.email,
      orderFor:params.data.orderFor, 
      partnerList:[{id:-1,text:strings.noMatter}],
      partnerListTotal:[{id:-1,text:strings.noMatter}],
      partnerSelected:{id:-1,text:strings.noMatter},
      purposeReturnAlready:(saveBook.returnAlready!=undefined)?saveBook.returnAlready:false,
      availableOption:availableOption, 
      availableListOption:availableListOption,
      enableOrderDriver:params.data.enableOrderDriver, 
      longRank:params.data.longRank, 
      cardList:[],
      cardSelected:{load:true},
      charge:"",
      favoriteDriver:(params.data.forcePartner!=false)?{id:params.data.forcePartner}:params.data.favoriteDriver,
      blackList:params.data.blackList,
      noZone:(taxiMode==true)?params.data.noZoneTaxi:params.data.noZone,
      destinationID:params.data.destinationID,
      deferredPayment:saveBook.deferredPayment,
      waitingPromo:true,
      waitingUserCard:true,
      waitingPartnerList:true,
      viewClientDetail:true,

      
      goReturnTaxi:false, 
      luggage:0,
      hideHoursMajoration:params.data.hideHoursMajoration,
      forceViewPartner:false,
      estimatePriceGo:estimatePriceGo, 
      paymentDriverMode:"client",
      paymentDriverModeTxt:strings.BillOptionForMaxDriver[0].text,
      hideOption:params.data.dispenser.enabled, 
      sendMessageIfPaiementError:params.data.sendMessageIfPaiementError, 

      viewFlightTrain:(params.data.enableFlightTrainVerif==true)?( (params.data.startTypeVerif=="flight" || params.data.destinationTypeVerif=="flight")?"flight":( (params.data.startTypeVerif=="train" || params.data.destinationTypeVerif=="train")?"train":false   ) ):false, 
      flightTrain:"",
      viewRoomHotel:(params.data.roomHotel==true)?((( (params.data.startAddress.toLowerCase().includes("hotel") || params.data.startAddress.toLowerCase().includes("hôtel")) && !params.data.startAddress.toLowerCase().includes("hotel de ville") && !params.data.startAddress.toLowerCase().includes("hôtel de ville")  ) || ( params.data.endAddress!=undefined && (params.data.endAddress.toLowerCase().includes("hotel") || params.data.endAddress.toLowerCase().includes("hôtel")) && !params.data.endAddress.toLowerCase().includes("hotel de ville") && !params.data.endAddress.toLowerCase().includes("hôtel de ville")  ))?true:false ):false


      
      

      


    };


    
    
  }
  
  onClientSelected = data => {
    if(this.state.onClientSelectedPassager!="false" && data.noClientPassager!=true){

      var passagersList=this.state.passagersList;

      passagersList[this.state.onClientSelectedPassager].name=data.name;
      passagersList[this.state.onClientSelectedPassager].lastName=data.lastName;
      passagersList[this.state.onClientSelectedPassager].phone=data.phone;

      this.setState({passagersList:passagersList},() =>{this.saveBook() }) 

    }
    else {


      this.chooseName.resetSuggestions()
      this.chooseEnterprise.resetSuggestions()
      this.chooseLastName.resetSuggestions()


      if(data.orderFor==true){
          this.setState({
            providerEnterprise:(data.enterprise!=undefined)?data.enterprise:"",
            providerAdressBill:(data.adressBill!=undefined)?data.adressBill:"",
            providerCityBill:(data.cityBill!=undefined)?data.cityBill:"",
            providerEmail:(data.email!=undefined)?data.email:"",
            providerID:data.clientID,
            orderForInfo:true,
            providerName:data.name, 
            providerLastName:data.lastName, 
          },() =>{this.saveBook() }) 
      }

      else this.setState({
        lastName:data.lastName,
        name:data.name,
        email:data.email,
        phone:data.phone,
        enterprise:(data.enterprise!=undefined)?data.enterprise:"",
        adressBill:(data.adressBill!=undefined)?data.adressBill:"",
        cityBill:(data.cityBill!=undefined)?data.cityBill:"",
        clientID:data.clientID,},() =>{this.saveBook() }) 



        this.testPromoCode(data.clientID)


        if(data.usersMoreInfosDriver!=undefined && data.usersMoreInfosDriver!="") this.setState({description:this.state.description+" "+data.usersMoreInfosDriver})
    }

  }

  useCard = data => { 
    this.setState({cardSelected:data})
    this.getUserCards()

  }

  getUserCards(){
    getAuth(firebase).currentUser.getIdToken().then(token => {
              var body={
                  userID:getAuth(firebase).currentUser.uid,
                  bundleIdentifer:info.bundleIdentifer,
                  token:token,
                  bundleAdress:info.firebaseProjectID,
                  version:info.appliVersion,
              }

          get(child(ref(getDatabase(firebase)), '/users/'+getAuth(firebase).currentUser.uid+"/email")).then(snapshot => { 
              var email=snapshot.val();
              body.email=email;
                console.log(body)
                fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getUserCards", {
                  body: JSON.stringify(body),method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {

                    console.log("get user card")
                        var res=responseJson;
                        var i=0;
                        var oldNoCardDetected=this.state.noCardDetected;
                        this.setState({waitingUserCard:false, noCardDetected:(responseJson==null || !(res.length>0) )?true:false    })
                        
                        for(i=0;i<res.length;i++){
                          res[i].text="*"+res[i].last4;
                          res[i].last4=((res[i].brand.toLowerCase()==="visa")?"Visa":((res[i].brand.toLowerCase()==="mastercard")?"Mastercard":((res[i].brand.toLowerCase()==="amex")?"AMEX":"")))+" *"+res[i].last4;
                          
                          res[i].icon=(res[i].brand.toLowerCase()==="visa")?require("../assets/visa.png"):((res[i].brand.toLowerCase()==="mastercard")?require("../assets/mastercard.png"):((res[i].brand.toLowerCase()==="amex")?require("../assets/amex.png"):require("../assets/paymentCard.png")))
                          res[i].image=(res[i].brand.toLowerCase()==="visa")?require("../assets/visa.png"):((res[i].brand.toLowerCase()==="mastercard")?require("../assets/mastercard.png"):((res[i].brand.toLowerCase()==="amex")?require("../assets/amex.png"):require("../assets/paymentCard.png")))
                        }

                      

                      if(info.disableOnBoardPayment!=true || (info.disableOnBoardPaymentExceptProvider==true && this.state.provider==true)){
                        res[i]={text:strings.paiementOnBoard, textSmall:"("+strings.cashOrCard+")", icon:require("../assets/paymentCash.png"),image:require("../assets/paymentCash.png"),onBoard:true,id:"onBoard"}
                        res[i+1]={text:strings.addCard,id:"addCard",image:require("../assets/paymentCard.png")}
                        res[i+2]={text:strings.withCredit,id:"withCredit",withCredit:true,image:require("../assets/paymentTransfer.png"),icon:require("../assets/paymentTransfer.png")}
                      }
                      else {
                          res[i]={text:strings.withCredit,id:"withCredit",withCredit:true,image:require("../assets/paymentTransfer.png") }
                          res[i+1]={text:strings.addCard,id:"addCard",image:require("../assets/paymentCard.png"),icon:require("../assets/paymentTransfer.png")}
                      }

                      if(info.withBancontact==true) res.push({text:strings.withBancontact,id:"withBancontact", icon:require("../assets/paymentBancontact.png"), withBancontact:true}); 

                      

                        
                        
                    
                      

                      var st={cardList:res, viewAddCard:false};
                      if(this.state.cardSelected.load===true || oldNoCardDetected==true) st.cardSelected=res[0]
                      
                      this.setState(st,() =>{this.calculateMajoration()})
                      
                    
                      
                    }).catch((err) => { console.log("error getUserCards"); console.log(err); timer.setTimeout("getUserCards", () => { this.getUserCards();  }, 2000);   })
                  .catch((err) => { console.log("error getUserCards"); console.log(err); timer.setTimeout("getUserCards", () => { this.getUserCards();  }, 2000);   })
            });
        })
}

  saveBook = data => { 
      var save={name:this.state.name,lastName:this.state.lastName,clientID:this.state.clientID,deferredPayment:this.state.deferredPayment, passagerNumber:this.state.passagerNumber,phone:this.state.phone,email:this.state.email,enterprise:this.state.enterprise,adressBill:this.state.adressBill,cityBill:this.state.cityBill,description:this.state.description,passagersList:this.state.passagersList}
      this.state.params.saveBook(save)
  }

  firebaseSendByMail = bodyInfo => { 
    console.log("firebaseSendByMail launch")
      fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/sendByMail", {body: JSON.stringify(bodyInfo),method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {}).catch((err) => { console.log("error firebaseSendByMail"); console.log(err); timer.setTimeout("firebaseSendByMail", () => { this.firebaseSendByMail(bodyInfo);  }, 2000);   })
                                
  }

  firebaseSendByMessage = bodyInfo => { 
    console.log("firebaseSendByMessage launch")
      fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/sendMessage", {body: JSON.stringify(bodyInfo),method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {}).catch((err) => { console.log("error sendMessage"); console.log(err); timer.setTimeout("sendMessage", () => { this.sendMessage(bodyInfo);  }, 2000);   })
                                
  }

  sendBooking(lk){
    this.setState({waiting:true})
    var uuid=generateUUID();

    if(lk=="quotation"){
      this.setState({waiting:false})
      this.sendBookingToFirebase(uuid, "waiting_quotation")
    }
    else if(lk=="myPos"){
      console.log("j'utilise myPos")

      this.setState({waiting:false},() =>{this.sendBookingToFirebase(uuid,("waiting_mypos"))})

    }
    else if(lk!=undefined){
        console.log("j'envoi la course avec un lien de paiement");

        var amountStripe=parseFloat(this.state.estimatePriceGo.realPrice.priceTotal)
        var precision=(this.state.params.data.pricingPrecise===true)?100:1;
        amountStripe=Math.round(amountStripe*precision)/precision


        getAuth(firebase).currentUser.getIdToken().then(token => {
          var body={
            raceID:uuid,
            token:token,
            capture:(lk=="bancontact" || (this.state.partnerSelected.id==getAuth(firebase).currentUser.uid))?"automatic":'manual', 
            currency:this.state.money.stripeCode,
            price:amountStripe, 
            token:token,
            userID:getAuth(firebase).currentUser.uid,
            bundleAdress:info.firebaseProjectID,
            bundleIdentifer:info.bundleIdentifer,
            version:info.appliVersion,
            name: 'Votre course du '+this.state.date,
            description: this.state.startAddress+ ((this.state.endAddress!=undefined && this.state.endAddress!="")?(' => '+this.state.endAddress):""),
          }




          if(info.withBancontact==true) body.withBancontact=true; 
          console.log(" fetch getPaymentURL")

          console.log(body)
          this.setState({waitGetPaymentURL:true})

          fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getPaymentURL", {
                body: JSON.stringify(body),method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {
                  
                  var rep=responseJson;
                  if(rep.sessionId!=undefined && rep.charge!=undefined){
                      this.setState({waiting:false, waitGetPaymentURL:false, charge:rep.charge},() =>{this.sendBookingToFirebase(uuid,((lk=="bancontact")?"waiting_bancontact":"waiting_customer_payment"),rep)})
                  }

          }).catch((err) => { console.log("error getPaymentURL"); console.log(err); timer.setTimeout("getPaymentURL", () => { this.sendBooking(lk);  }, 2000);   })




        })

    }

    else if(this.state.taxiMode!=true && info.paymentCardApp===true && (this.state.cardSelected.last4!==undefined || this.state.cardSelected.withCredit==true) && this.state.deferredPayment!=true ){

    	var amountStripe=parseFloat(this.state.estimatePriceGo.realPrice.priceTotal)
    	var precision=(this.state.params.data.pricingPrecise===true)?100:1;
    	amountStripe=Math.round(amountStripe*precision)/precision
      
      getAuth(firebase).currentUser.getIdToken().then(token => {
              var body={
                  currency:this.state.money.stripeCode, 
                  moneyID:this.state.money.id,
                  userID:getAuth(firebase).currentUser.uid,
                  bundleIdentifer:info.bundleIdentifer,
                  price:amountStripe,
                  source:this.state.cardSelected.id,
                  raceID:uuid,
                  token:token,
                  bundleAdress:info.firebaseProjectID,
                  version:info.appliVersion,
                  withURL:true,
              }


              console.log(" fetch getProvision")
              this.setState({waitGetProvision:true})
              fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getProvision", {
                body: JSON.stringify(body),
                method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {
                  
                      var rep=responseJson;
                      console.log("on a recu la réponse")
                      console.log(rep)
                      
                      if(rep.payment==="ok"){
                        this.setState({waitGetProvision:false,charge:rep.charge,waiting:false},() =>{this.sendBookingToFirebase(uuid)})
                        
                      }
                      else if(rep.payment==="requires_action" && rep.urlRedirect!=undefined && false){
                          console.log("je suis dans requires_action et rep.urlRedirect azerty") 
                          this.setState({waitGetProvision:false, charge:rep.charge, urlRedirect:rep.urlRedirect },() =>{this.sendBookingToFirebase(uuid,"requires_action",{urlRedirect:true} )})
                      }

                      else if(rep.payment==="requires_action"){
                          console.log("je suis dans requires_action")
                          this.setState({waitGetProvision:false, charge:rep.charge,waiting:false},() =>{this.sendBookingToFirebase(uuid,"requires_action")})
                      }
                      else{
                        this.setState({waitGetProvision:false})
                        if(rep.error=="insufficientCredit"){
                          this.alert.onAlert({title:strings.insufficientCredit,subTitle:strings.rechargeCreditifinsufficient,
                            buttons:[{text: strings.yes,onPress: () => {var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params;params.navigate('Payment',{addCredit:true, useCard:this.useCard})}},{text: strings.cancel,style:"cancel", onPress: () => {}}]})

                          

                        }
                        else {
                          this.alert.onAlert({title:strings.errorCard});

                          if(this.state.sendMessageIfPaiementError===true) {
                            var list="Tentative de paiement echoué de "+this.state.name+" "+this.state.lastName+". Course au départ de "+this.state.startAddress;
                            if(this.state.endAddress!="") list+=" et à destination de "+this.state.endAddress; 


                            getAuth(firebase).currentUser.getIdToken().then(token => {

                                var bodyInfo={
                                    toEmail:info.companyEmail,
                                    toName:info.companyBrand, 
                                    subject: "Echec de paiement", 
                                    HTMLPart:list, 
                                    replyToEmail:info.companyEmail,
                                    replyToName:info.companyBrand,
                                    token:token,
                                    fromEmail:info.mavEmail,
                                    fromName:info.companyBrand,
                                    userID:getAuth(firebase).currentUser.uid,

                                }

                                this.firebaseSendByMail(bodyInfo)

                            })



                            
                          }

                        }
                      
                      this.setState({waiting:false})
                      }


             }).catch((err) => { console.log("error getProvision"); console.log(err); timer.setTimeout("getProvision", () => { this.sendBooking(lk);  }, 2000);   })

          })

    } else {
      this.setState({waiting:false})
      this.sendBookingToFirebase(uuid)
    }


        
      

  }


sendMessage(sendVia, trackLink, phone,driverText, next, paiement){

    if(paiement!=false && paiement!=undefined && paiement!="" && (sendVia=="sms" || sendVia=="whatsapp") ) {
      paiement=paiement.replace("&","AND"); 

    }

    var messageNotif="Bonjour, nous sommes heureux de vous confirmer votre réservation du "+this.state.date;
    if(paiement!=false) {
      messageNotif+=". Réglez votre course via ce lien : "+paiement; 
    }
    messageNotif+=((trackLink!="")?(". "+((paiement!=false)?" Après, vous":"Vous")+" pourrez suivre la course ici :"+trackLink):"")
    messageNotif+=". "+info.companyBrand
    var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params;
    var smssearch;
    if(paiement!=false && paiement!=undefined && paiement!="") smssearch=((trackLink!="")?"validatePT":"validateP")
    else smssearch=((trackLink!="")?"validateT":"validate")

    get(child(ref(getDatabase(firebase)), '/prefill/sms/'+smssearch+"/fr")).then(valuePrefill => {
       var valPrefill=valuePrefill.val();
       if(valPrefill!=null) {
            messageNotif=valPrefill.name;
            messageNotif = messageNotif.split('%NAME%').join((this.state.name!=undefined)?this.state.name:"")
            messageNotif = messageNotif.split('%LASTNAME%').join((this.state.lastName!=undefined)?this.state.lastName:"")
            messageNotif = messageNotif.split('%DATE%').join(this.state.date) 
            messageNotif = messageNotif.split('%START%').join((this.state.startAddress!=undefined)?this.state.startAddress:"")
            messageNotif = messageNotif.split('%PRICE%').join(((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.estimatePriceGo.realPrice.priceTotal+((this.state.money.position=="right")?(this.state.money.symbole):"")) 
            messageNotif = messageNotif.split('%END%').join((this.state.endAddress!=undefined)?this.state.endAddress:"mise à disposition")
            messageNotif = messageNotif.split('%TRACKLINK%').join(trackLink)
            if(paiement!=false && paiement!=undefined && paiement!="") messageNotif = messageNotif.split('%PAYLINK%').join(paiement)
            messageNotif = messageNotif.split('%DRIVER%').join( (driverText!=undefined && driverText!="" && driverText.text!=undefined)?driverText.text:"pas encore attribué"); 

        }
        /*messageNotif=encodeURIComponent(messageNotif);*/
        console.log("message "+messageNotif)

        if(sendVia=="sms" || sendVia=="whatsapp"){
            if(sendVia=="sms") this.sendWithSMS(messageNotif); 
            else Linking.openURL('whatsapp://send?text='+messageNotif+((Platform.OS === 'ios')?"&":"?")+"phone="+phone )

            
            this.state.params.updateAfterBook()
            params.popToTop();
            if(next==true) this.state.params.purposeReturn();
            

        }
        else {

              getAuth(firebase).currentUser.getIdToken().then(token => {
                      var phone=this.state.phone;
                      if(phone[0]=="+" && phone[1]==3 && phone[2]==3 && phone[3]==0) phone="+33"+phone.slice(4)
                      else if (phone[0]==0 && info.countryCode=="fr") phone="+33"+phone.slice(1);
                      else if(phone[0]=="+" && phone[1]==5 && phone[2]==9 && phone[3]==0 && phone[4]==0) phone="+590"+phone.slice(5)
                      else if (phone[0]==0 && info.countryCode=="gp") phone="+590"+phone.slice(1);

                      var bodyInfo={
                          message:messageNotif, 
                          sms:true,
                          phone:phone,
                          token:token,
                          securisedTask:true,
                          userID:getAuth(firebase).currentUser.uid,
                          bundleAdress:info.firebaseProjectID,
                      }

                      console.log(bodyInfo)
                      this.firebaseSendByMessage(bodyInfo)
                      this.state.params.updateAfterBook()
                      params.popToTop();
                      if(next==true) this.state.params.purposeReturn();

              })

        }
        

    })

    
    
  }










  sendBookingToFirebase(uuid,opt, paramsOpt){
        console.log("sendBookingToFirebase")
        console.log(paramsOpt)
        const style=styleInfo();

        /*
        var date=this.state.date;
        date=new Date(date[6]+date[7]+date[8]+date[9]+'-'+date[3]+date[4]+'-'+date[0]+date[1]+'T'+date[13]+date[14]+':'+date[16]+date[17]+':00')
        date=Date.parse(date)+date.getTimezoneOffset()*60000;
        */

        var dateOrder=Date.parse(new Date(Date.now()));
        var precision=(this.state.params.data.pricingPrecise==true)?100:1

        var commentaire="";
                
        if(this.state.params.data.hideMajoration!=true && this.state.estimatePriceGo.realPrice.majorationDate!=undefined && this.state.estimatePriceGo.realPrice.majorationDate.amount!=0) commentaire+= ((this.state.estimatePriceGo.realPrice.majorationDate.name!="saturday")?((this.state.estimatePriceGo.realPrice.majorationDate.name!="sunday")? (  (this.state.estimatePriceGo.realPrice.majorationDate.name!="night")? (  (this.state.estimatePriceGo.realPrice.majorationDate.name!="ferie")? ( (this.state.estimatePriceGo.realPrice.majorationDate.name!="morning")? ( (this.state.estimatePriceGo.realPrice.majorationDate.name!="evening" && this.state.estimatePriceGo.realPrice.majorationDate.name!="completeNight" )? (  (this.state.estimatePriceGo.realPrice.majorationDate.name!="dynamic") ?  ( (this.state.estimatePriceGo.realPrice.majorationDate.name!="afternoon" )? ( (this.state.estimatePriceGo.realPrice.majorationDate.name=="highAffluence") ?"Majoration haute affluence" :((this.state.estimatePriceGo.realPrice.majorationDate.name=="majoOther")?"Majoration horaire":"Majoration passagers")   ) : "Majoration après midi"  )     : "Majoration dynamique"   )                        : "Majoration soir" )  : "Majoration matin" ) : "Majoration jour férié"      ) : "Majoration nuit "   ) : "Majoration dimanche" ):"Majoration samedi"  )+ " : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.estimatePriceGo.realPrice.majorationDate.amount+((this.state.money.position=="right")?(this.state.money.symbole):"")+" - "
        if(this.state.params.data.hideMajoration!=true && this.state.estimatePriceGo.realPrice.majorationRealTime!=undefined && this.state.estimatePriceGo.realPrice.majorationRealTime!=0) commentaire+="Majoration bouchon : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+(Math.round( this.state.estimatePriceGo.realPrice.majorationRealTime *precision)/precision) +((this.state.money.position=="right")?(this.state.money.symbole):"")+" - ";
        if(this.state.params.data.hideMajoration!=true && this.state.estimatePriceGo.realPrice.avanceOrder!=undefined && this.state.estimatePriceGo.realPrice.avanceOrder!=0) commentaire+="Majoration réservation à l'avance : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+(Math.round( this.state.estimatePriceGo.realPrice.avanceOrder *precision)/precision)+((this.state.money.position=="right")?(this.state.money.symbole):"")+" - ";
        if(this.state.params.data.hideMajoration!=true && this.state.estimatePriceGo.realPrice.lastMinute!=undefined && this.state.estimatePriceGo.realPrice.lastMinute!=0) commentaire+="Majoration de dernières minutes : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+(Math.round( this.state.estimatePriceGo.realPrice.lastMinute *precision)/precision)+((this.state.money.position=="right")?(this.state.money.symbole):"")+" - ";





        if(this.state.estimatePriceGo.realPrice.promo!=undefined && this.state.estimatePriceGo.realPrice.promo.amount!=0){

          if(this.state.estimatePriceGo.realPrice.promo.id=="PERMANENT") commentaire+="Réduction permanente de "+(this.state.estimatePriceGo.realPrice.promo.percent*100)+"% - "
          else if(this.state.estimatePriceGo.realPrice.promo.percent>0) commentaire+="Réduction de "+(this.state.estimatePriceGo.realPrice.promo.percent*100)+"% avec le code promo "+this.state.estimatePriceGo.realPrice.promo.name+" - ";
          else commentaire+="Réduction avec le code promo "+this.state.estimatePriceGo.realPrice.promo.name+" - ";
        }

       

       

        var sendToFirebase={
          clientName: this.state.name,
          clientLastName:this.state.lastName,
          clientEmail:(this.state.email==undefined)?null:this.state.email,
          clientPhone:(this.state.phone==undefined)?null:this.state.phone,
          racePlaceStartName:this.state.startAddress,
          estimatePrice:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.estimatePriceGo.realPrice.priceTotal+((this.state.money.position=="right")?(this.state.money.symbole):""),
          moneyID:this.state.money.id,
          carName:this.state.carName,
          estimateKm:this.state.estimateKm,
          orderDate:dateOrder,
          raceDate:this.state.integerDate,
          estimateTimeValue:this.state.timeEstimation,
          raceDateFixed:this.state.date, 
          languageID:strings.idLangue,
          passagers:(this.state.passagersList.length>0)? (this.state.passagersList.length+1)  : this.state.passagerNumber, 

          
        }
        var addDriverPrice=0;
        var selectedOptions=this.state.selectedOptions;

        if(info.bundleIdentifer=="mi18b4d3"){ 
          sendToFirebase.originCoord={lat:this.state.coords[0].latitude,lng:this.state.coords[0].longitude}
          sendToFirebase.destinationCoord={lat:this.state.coords[this.state.coords.length-1].latitude,lng:this.state.coords[this.state.coords.length-1].longitude}
          

        }
        

        if(this.state.selectedOptions!=undefined && this.state.selectedOptions.luggage!=undefined && (this.state.selectedOptions.luggage.value==true || this.state.selectedOptions.luggage.value>1)) {
          sendToFirebase.luggage=(this.state.selectedOptions.luggage.value==true)?1:this.state.selectedOptions.luggage.value
          delete selectedOptions.luggage;
        }

        if(selectedOptions!=undefined && Object.keys(selectedOptions).length>0) sendToFirebase.selectedOptions=selectedOptions;

        if(this.state.cpam==true) sendToFirebase.cpam=true;

        if(this.state.tvaNumber!=undefined && this.state.tvaNumber!="") sendToFirebase.tvaNumberClient=this.state.tvaNumber; 

        if(this.state.noVAT==true){
          sendToFirebase.noVAT=true;
          addDriverPrice= (this.state.estimatePriceGo.realPrice.priceTotal*(1+ ( (this.state.racePlaceEndName!=undefined)?info.tvaPercentDispo:info.tvaPercentClassic  ) /100))-this.state.estimatePriceGo.realPrice.priceTotal;
          addDriverPrice=addDriverPrice.toFixed(2); 
          addDriverPrice=parseFloat(addDriverPrice)
          
        }
        if(this.state.promo!=undefined && this.state.promo!="" && this.state.promo.takeCost==true){
          addDriverPrice+=parseFloat(this.state.estimatePriceGo.realPrice.promo.amount)
        }

        if(addDriverPrice>0) sendToFirebase.addDriverPrice=addDriverPrice;

        if(this.state.stopList!=undefined && this.state.stopList.length>0){
          sendToFirebase.stopList=this.state.stopList; 

        }

        if(this.state.passagersList.length>0){

          sendToFirebase.passagersList=this.state.passagersList;
          var supVi;
          for(supVi=0; supVi<this.state.passagersList.length; supVi++){
              delete sendToFirebase.passagersList[supVi].view
              if(sendToFirebase.passagersList[supVi].phone==undefined || sendToFirebase.passagersList[supVi].phone=="") delete sendToFirebase.passagersList[supVi].phone;
          }
        }
        if(this.state.multipleCar>1) commentaire+=this.state.multipleCar+" "+((this.state.multipleCar<2)?strings.car:strings.cars)+" - ";
        if(this.state.roomHotel!="") commentaire+="Numéro de chambre "+this.state.roomHotel+" - "; 


        commentaire+=this.state.description;
        sendToFirebase.description=commentaire;


        if(this.state.co2!=undefined) sendToFirebase.co2=this.state.co2; 
        if( this.state.driver==false && this.state.partner==false && this.state.params.data.vipMode==true && this.state.params.data.vip==true) sendToFirebase.vip=true;
        if(this.state.params.data.sendMailToAdmin==true) sendToFirebase.sendMailToAdmin=true;

        if((this.state.driver!=true && this.state.provider!=true && this.state.partner!=true && this.state.customerPro!=true) && this.state.params.data.activateCustomerNotation==true) sendToFirebase.activateCustomerNotation=true;
        if((this.state.driver!=true && this.state.provider!=true && this.state.partner!=true && this.state.customerPro!=true) && this.state.params.data.activateDriverNotation==true) sendToFirebase.activateDriverNotation=true;
        


        if(this.state.alreadyPaid==true) sendToFirebase.alreadyPaid=true;
        if(this.state.notBill==true) sendToFirebase.notBill=true;
        

        if(this.state.paymentDriverMode!="client" && (this.state.driver==false && (this.state.partner==true && this.state.params.data.privilegeDriver=="max" ) )) sendToFirebase.paymentDriverMode=this.state.paymentDriverMode;
        else if(this.state.driver==true && this.state.forceDriverPrice==true && this.state.forceDriverPriceAmount!=""){ var amountDr=parseFloat(this.state.forceDriverPriceAmount); if(amountDr!=NaN && amountDr!="NaN") sendToFirebase.forceDriverPrice=this.state.forceDriverPriceAmount  }

        if(this.state.params.data.removeRace5minutes==true) sendToFirebase.removeRace5minutes=true;

        if(this.state.endAddress!="") sendToFirebase.racePlaceEndName=this.state.endAddress;
        if(this.state.estimatePriceGo.realPrice.promo!=undefined && this.state.estimatePriceGo.realPrice.promo.amount!=0) sendToFirebase.promoCode={name:this.state.estimatePriceGo.realPrice.promo.name,reduc:this.state.estimatePriceGo.realPrice.promo.percent, codeID:this.state.estimatePriceGo.realPrice.promo.id}
        if(this.state.charge!=""){sendToFirebase.charge=this.state.charge;this.setState({charge:""})}
        var sa;
        

        if(this.state.enterprise!="" && this.state.enterprise!=undefined) sendToFirebase.clientEnterprise=this.state.enterprise
        if(this.state.adressBill!="" && this.state.adressBill!=undefined) sendToFirebase.clientAdressBill=this.state.adressBill
        if(this.state.cityBill!="" && this.state.cityBill!=undefined) sendToFirebase.clientCityBill=this.state.cityBill





        if(this.state.providerID!=undefined ){
          sendToFirebase.providerID=this.state.providerID;
          sendToFirebase.providerName=(this.state.providerName!=undefined)?this.state.providerName:"Admin";
          sendToFirebase.providerLastName=(this.state.providerLastName!=undefined)?this.state.providerLastName:"Admin";
          sendToFirebase.providerEmail=(this.state.providerEmail!=undefined)?this.state.providerEmail:info.companyEmail;

          if(this.state.charge!="" || this.state.deferredPayment==true){
            if(this.state.driver!=true){
                sendToFirebase.providerBill=true;
                if(this.state.estimatePriceGo.realPrice.priceTotalWithProvCom!=undefined && this.state.estimatePriceGo.realPrice.priceTotalWithProvCom!=this.state.estimatePriceGo.realPrice.priceTotal) sendToFirebase.indicativePriceCustomer=this.state.estimatePriceGo.realPrice.priceTotalWithProvCom; 
            }
            
          } else {
              if(this.state.providerCommission>0) sendToFirebase.providerCommission= this.state.providerCommission
              if(this.state.estimatePriceGo.provCom!=undefined && this.state.estimatePriceGo.provCom>0) sendToFirebase.providerCommissionFixe=this.state.estimatePriceGo.provCom; 
          
          }
            
          
          if(this.state.providerEnterprise!="" && this.state.providerEnterprise!=undefined) sendToFirebase.providerEnterprise=this.state.providerEnterprise;
          if(this.state.providerAdressBill!="" && this.state.providerAdressBill!=undefined) sendToFirebase.providerAdressBill=this.state.providerAdressBill;
          if(this.state.providerCityBill!="" && this.state.providerCityBill!=undefined) sendToFirebase.providerCityBill=this.state.providerCityBill;




        }

        else if(this.state.doubtInfo!=undefined){

          /*je vais stocker des infos sur la course*/
          sendToFirebase.doubt=true; 
          const fireInfo={} 
          fireInfo["doubt/"+uuid]=this.state.doubtInfo; 
          update(ref(getDatabase(firebase)), fireInfo)

        }

        if(this.state.customerPro==true){
          sendToFirebase.customerPro=true; 
          sendToFirebase.customerProName=this.state.providerName;
          sendToFirebase.customerProLastName=this.state.providerLastName;
          sendToFirebase.customerProEmail=this.state.providerEmail;
          if(this.state.providerEnterprise!="" && this.state.providerEnterprise!=undefined) sendToFirebase.customerProEnterprise=this.state.providerEnterprise;
          if(this.state.providerAdressBill!="" && this.state.providerAdressBill!=undefined) sendToFirebase.customerProAdressBill=this.state.providerAdressBill;
          if(this.state.providerCityBill!="" && this.state.providerCityBill!=undefined) sendToFirebase.customerProCityBill=this.state.providerCityBill;
        


        }



        if(this.state.driver!=true && this.state.provider!=true && this.state.partner!=true) sendToFirebase.clientID=getAuth(firebase).currentUser.uid
        else if(this.state.driver==true && this.state.clientID!="" && this.state.clientID!=undefined) sendToFirebase.clientID=this.state.clientID;

        sendToFirebase.status="waiting";
        
        if(this.state.deferredPayment==true) sendToFirebase.deferredPayment=true;

        
        if(this.state.partnerSelected.id!=-1) {
          sendToFirebase.desiredDriver={id:this.state.partnerSelected.id,text:this.state.partnerSelected.text,other:this.state.partnerList};
          if(this.state.params.data.removeFavoriteDriver30==true) sendToFirebase.desiredDriver.removeFavoriteDriver30=true;
        }
        else sendToFirebase.desiredDriver={noPartner:true,other:this.state.partnerList}
        
        if(this.state.forceManualDispatch==true) sendToFirebase.desiredDriver.forceManualDispatch=true;

        if(this.state.longRank==true && this.state.params.data.immediate!=true && this.state.enableOrderDriver==true) sendToFirebase.desiredDriver.longRank=true; 
            

        
    	
        if(this.state.driver==true || this.state.partner==true) {


          if((this.state.driver==true && this.state.forceDesired!=true && this.state.partnerSelected.id!=-1) || (this.state.partner==true && this.state.partnerSelected.id==getAuth(firebase).currentUser.uid) ){
              sendToFirebase.attributedPartner={id:this.state.partnerSelected.id,text:this.state.partnerSelected.text}
              sendToFirebase.desiredDriver={id:this.state.partnerSelected.id,text:this.state.partnerSelected.text,other:this.state.partnerList,noMessage:true};
              sendToFirebase.status="validate";

              
              if(this.state.partnerSelected.id!=getAuth(firebase).currentUser.uid && this.state.params.data.confirmAttributedRace==true) sendToFirebase.confirmAttributedRace=true; 

              if(this.state.partnerSelected.id!=getAuth(firebase).currentUser.uid && opt!="waiting_quotation" && opt!="waiting_customer_payment" && opt!="waiting_bancontact") getAuth(firebase).currentUser.getIdToken().then(token => {

                      var body={securisedTask:true,userID:getAuth(firebase).currentUser.uid,bundleIdentifer:info.bundleIdentifer,message:"Une course vous a été attribué. Ouvrez l'appli pour en savoir plus",clientID:this.state.partnerSelected.id,token:token,title:"Nouvelle course pour le "+this.state.date,bundleAdress:info.firebaseProjectID,}
                      this.firebaseSendByMessage(body)

              })

          }

        }
        


        if(this.state.params.data.immediate==true) sendToFirebase.immediate=true;

        if(this.state.viewFlightTrain!=false && this.state.flightTrain!=""){
          if(this.state.viewFlightTrain=="train") sendToFirebase.numTrain=this.state.flightTrain;
          else sendToFirebase.numFlight=this.state.flightTrain
        }
        

        

        if(this.state.taxiMode==true){
          sendToFirebase.taxiMode=true;
          if(this.state.goReturnTaxi==true){
              sendToFirebase.goReturnTaxi=true;
              sendToFirebase.estimateTimeValue=this.state.timeEstimation*2
              sendToFirebase.estimateKm=(parseFloat(sendToFirebase.estimateKm.replace(",","."))*2)+" km"

          }
        }

       

        console.log(sendToFirebase);
        console.log("uuid== "+uuid)

        var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params;

      
        

        if(opt=="waiting_bancontact") sendToFirebase.withBc=true;
        if(opt=="waiting_mypos") sendToFirebase.withMyPOS=true;
        if(opt=="waiting_customer_payment" || opt=="waiting_bancontact"){
            sendToFirebase.sessionId=paramsOpt.sessionId
        }
        

    
        
      

      
        

        
      
        
        

       var trackLink=(info.trackLink!=undefined && (this.state.driver==true || this.state.partner==true || this.state.provider==true || this.state.customerPro==true ) )?(info.trackLink+"/?trackLink="+uuid):""; 

        
        
        
       if(opt=="waiting_bancontact"){
          


          this.alert.onAlert({title:strings.raceHasBeenValidate, subTitle:strings.raceOkAfterBancontact,buttons: [ {text: strings.next,onPress: () => {
              this.sendRaceInfoToFirebase(uuid, opt, sendToFirebase)
              var value="https://stripe.mon-appli-vtc.com/?sessionId="+paramsOpt.sessionId+"&publicKey="+info.stripePublicKey
              Linking.openURL(value)
              this.state.params.updateAfterBook()
              params.popToTop();

             
         } } ] })

       }
       else if(opt=="waiting_mypos"){
          
          this.alert.onAlert({title:strings.raceHasBeenValidate, subTitle:strings.raceOkAfterMypos,buttons: [ {text: strings.next,onPress: () => {
              this.sendRaceInfoToFirebase(uuid, opt, sendToFirebase)
              var value="https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/myPos/pay/"+uuid;
              Linking.openURL(value)
              this.state.params.updateAfterBook()
              params.popToTop();

             
         } } ] })

       }

        
        else if(this.state.driver!=true && this.state.partner!=true){
          this.sendRaceInfoToFirebase(uuid, opt, sendToFirebase)

          
          if(this.state.params.data.immediate==true && this.state.customerPro!=true && this.state.provider!=true) this.state.params.updateAfterBook({immediate:true,raceUUID:uuid})
          else this.state.params.updateAfterBook()
          
          if(opt!="requires_action"){
            /* test si j'affiche le lien */
            if(trackLink!=""){
              var qrInfo={url:trackLink, callback:params.popToTop };
              if(this.state.phone!="") qrInfo.phone=this.state.phone;
              if(this.state.provider==true && this.state.dispenser==true) qrInfo.dispenser=true;  
              qrInfo.date=this.state.date;
              this.qrCode.onPicker(qrInfo);
            }
            else this.alert.onAlert({maxiMode:this.state.dispenser,check:(sendToFirebase.charge!=undefined)?true:false,  title:(this.state.dispenser===true)?strings.thanksOrder:((sendToFirebase.charge!=undefined)?strings.paymentValidate:strings.thanksWeWillReceiveAnConfirmationEmail), subTitle:(sendToFirebase.charge!=undefined)?strings.thanksWeWillReceiveAnConfirmationEmail:undefined,  buttons:[{text:strings.ok,onPress: () => {params.popToTop(); if(this.state.params.data.immediate!=true && this.state.taxiMode!=true && this.state.dispenser!=true && this.state.purposeReturn===true && opt!="requires_action" && opt!="waiting_bancontact" && opt!="waiting_customer_payment" && opt!="waiting_quotation" && this.state.endAddress!=undefined && this.state.endAddress!="" && this.state.purposeReturnAlready!=true)  this.state.params.purposeReturn();     }}],});
          }
          else {
            console.log("je déclanche le 3D secure")
            if(paramsOpt==undefined || paramsOpt.urlRedirect!=true){
                params.popToTop();
                this.state.params.start3DSecure();
            } 
            

          }
            
        }

        else{

          var value=false;
          if(opt=="waiting_customer_payment"){

            value=((info.stripeURL!=undefined)?info.stripeURL:"https://stripe.mon-appli-vtc.com/")+"?sessionId="+paramsOpt.sessionId+"&publicKey="+info.stripePublicKey
            if(Platform.OS!="web") this.copyToClipboard(value)
          }

          var buttons=[];
          var infoEmail="";
          var linkQuotation="https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/validateQuote/"+uuid; 

          if(Platform.OS!="web" && this.state.phone!=undefined && this.state.phone!=""){
            buttons.push({text: strings.withSMS,onPress: () => {
              this.sendRaceInfoToFirebase(uuid, opt, sendToFirebase)
              this.sendMessage("sms", trackLink, "",sendToFirebase.attributedPartner, (this.state.params.data.immediate!=true && this.state.taxiMode!=true && this.state.dispenser!=true && this.state.purposeReturn===true && opt!="requires_action" && opt!="waiting_bancontact" && opt!="waiting_customer_payment" && opt!="waiting_quotation" && this.state.endAddress!=undefined && this.state.endAddress!="" && this.state.purposeReturnAlready!=true), value ); 

            }})


            buttons.push({text: strings.withWhatsApp,onPress: () => {
              this.sendRaceInfoToFirebase(uuid, opt, sendToFirebase)
              var phone=this.state.phone;
              if(phone!=undefined && phone[0]==0 && info.countryCode=="fr") phone="33"+phone;
              this.sendMessage("whatsapp", trackLink, phone,sendToFirebase.attributedPartner, (this.state.params.data.immediate!=true && this.state.taxiMode!=true && this.state.dispenser!=true && this.state.purposeReturn===true && opt!="requires_action" && opt!="waiting_bancontact" && opt!="waiting_customer_payment" && opt!="waiting_quotation" && this.state.endAddress!=undefined && this.state.endAddress!="" && this.state.purposeReturnAlready!=true), value ); 
               
            }})


          }

          if((Platform.OS=="web") && info.mailjetSMS==true && this.state.phone!=undefined && this.state.phone!=""){

            buttons.push({text: strings.withSMS,onPress: () => {
              this.sendRaceInfoToFirebase(uuid, opt, sendToFirebase)
              this.sendMessage("smsMailjet", trackLink, "",sendToFirebase.attributedPartner, (this.state.params.data.immediate!=true && this.state.taxiMode!=true && this.state.dispenser!=true && this.state.purposeReturn===true && opt!="requires_action" && opt!="waiting_bancontact" && opt!="waiting_customer_payment" && opt!="waiting_quotation" && this.state.endAddress!=undefined && this.state.endAddress!="" && this.state.purposeReturnAlready!=true), value ); 

                
            }})

          }



          if(this.state.email!=undefined && this.state.email!=""){

            let reg = /[a-z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,8}$/;
            if(reg.test(this.state.email) === true){
              infoEmail=buttons.length;
              buttons.push({text: strings.withMail,onPress: () => {
                  this.sendRaceInfoToFirebase(uuid, opt, sendToFirebase)


                  

                  var list="<html xmlns=\'http://www.w3.org/1999/xhtml\' xmlns:v=\'urn:schemas-microsoft-com:vml\' xmlns:o=\'urn:schemas-microsoft-com:office:office\'><head>  <title></title>  <!--[if !mso]><!-- -->  <meta http-equiv=\'X-UA-Compatible\' content=\'IE=edge\'>  <!--<![endif]--><meta http-equiv=\'Content-Type\' content=\'text/html; charset=UTF-8\'><meta name=\'viewport\' content=\'width=device-width, initial-scale=1.0\'><style type=\'text/css\'>  #outlook a { padding: 0; }  .ReadMsgBody { width: 100%; }  .ExternalClass { width: 100%; }  .ExternalClass * { line-height:100%; }  body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }  table, td { border-collapse:collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }  img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }  p { display: block; margin: 13px 0; }</style><!--[if !mso]><!--><style type=\'text/css\'>  @media only screen and (max-width:480px) {    @-ms-viewport { width:320px; }    @viewport { width:320px; }  }</style><!--<![endif]--><!--[if mso]><xml>  <o:OfficeDocumentSettings>    <o:AllowPNG/>    <o:PixelsPerInch>96</o:PixelsPerInch>  </o:OfficeDocumentSettings></xml><![endif]--><!--[if lte mso 11]><style type=\'text/css\'>  .outlook-group-fix {    width:100% !important;  }</style><![endif]--><style type=\'text/css\'>  @media only screen and (min-width:480px) {    .mj-column-per-100 { width:100%!important; }  }</style></head><body style=\'background: #efefefef;\'>    <div class=\'mj-container\' style=\'background-color:#efefefef;\'> <div style=\'margin:0px auto;max-width:600px;background:"+style.color1+";\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;background:"+style.color1+";\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 20px 0px 20px;\' align=\'center\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:center;\'><h1 style=\'font-family: Helvetica, sans-serif; color: #FFFFFF; font-size: 26px; line-height: 100%;\'>"+ ( (opt=="waiting_quotation")?"VOTRE DEVIS" :(  (opt=="waiting_customer_payment")?"RÉSERVATION EN ATTENTE DE PAIEMENT":"CONFIRMATION DE RÉSERVATION"  )  )+ "</h1></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><div style=\'margin:0px auto;max-width:600px;background:#FFFFFF;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;background:#FFFFFF;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:center;\'><p>"+((opt=="waiting_quotation")?("Vous trouverez votre devis ci-dessous. Nous vous remercions pour votre confiance"):("Nous vous confirmons votre r&#xE9;servation de trajet avec "+info.companyBrand) )+"</p></div><tr><td style=\'word-wrap:break-word;font-size:0px;padding:10px 25px;padding-top:17px;padding-bottom:17px;padding-right:30px;padding-left:30px;\'><p style=\'font-size:1px;margin:0px auto;border-top:1px dotted #929292;width:100%;\'></p><!--[if mso | IE]><table role=\'presentation\' align=\'center\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:1px;margin:0px auto;border-top:1px dotted #929292;width:100%;\' width=\'600\'><tr><td style=\'height:0;line-height:0;\'>&nbsp;</td></tr></table><![endif]--></td></tr><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 25px 0px 25px;\' align=\'left\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:left;\'><h2 style=\'font-family: Helvetica, sans-serif; line-height: 100%;\'>"+((this.state.endAddress=="")?"VOTRE MISE A DISPOSITION":"VOTRE TRAJET")+"</h2><p><strong>Départ </strong>: "+sendToFirebase.racePlaceStartName+"</p>"+((this.state.endAddress!="")?"<p><strong>Arrivée </strong>: "+sendToFirebase.racePlaceEndName+"</p>":"")+"<p><strong>Jour &amp; heure </strong>: "+this.state.date+"</p><p><strong>Durée </strong>: "+(((Math.floor(this.state.estimateTime/3600))<10)?"0":"")+Math.floor(this.state.estimateTime/3600)+":"+((Math.floor((this.state.estimateTime%3600)/60)<10)?"0":"")+Math.floor((this.state.estimateTime%3600)/60)+"</p>"+((this.state.endAddress!="")?"<p><strong>Km </strong>: "+this.state.estimateKm+"</p>":"")+"<p><strong>Véhicule </strong>: "+this.state.carName+"</p><p><strong>Prix </strong>: "+sendToFirebase.estimatePrice
                  if(value!=false) list+="</p><p><strong>Lien de paiement </strong>: <a href='"+value+"''>ici</a>";
                  list+="</p><p><strong>Commentaire </strong>: "+commentaire+"</p>"+((trackLink!="" && (opt!="waiting_quotation" && opt!="waiting_customer_payment") )?("<p><strong>Suivi de la course ici </strong>: "+trackLink+"</p>"):"")+"</div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;background:#FFFFFF;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 25px 0px 25px;\' align=\'center\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:center;\'><p>"+((opt=="waiting_customer_payment")?(""): ( (opt=="waiting_quotation")? ("Cliquez simplement <a href=\'"+linkQuotation+"\'>ici</a> pour confirmer votre demande et accepter le devis") : ("Pour toute annulation n\'oubliez pas de nous tenir inform&#xE9;s via l\'onglet contact de l\'application ou par email <a href=\'mailto:"+this.state.companyEmail+"?subject=Annulation&amp;body=Annulation\' style=\'color: "+style.color1+";\'>"+this.state.companyEmail+"</a>" )   ) ) +"</p></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></table><!--[if mso | IE]>      </td></tr></table>      <![endif]--><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;\'><div style=\'font-size:1px;line-height:50px;white-space:nowrap;\'>&nbsp;</div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'background:#333333;font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;\'><div style=\'font-size:1px;line-height:50px;white-space:nowrap;\'>&nbsp;</div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'background:#333333;font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 20px 0px 20px;\' align=\'center\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:11px;line-height:22px;text-align:center;\'><p><span style=\'color:#ffffff;\'>"+this.state.companyBrand+" | "+this.state.companyAdress+" | "+this.state.companyCity+" | "+this.state.companyPhone+" | "+this.state.companyEmail+"</span></p></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>      </td></tr></table>      <![endif]--></div></body></html>"                                                                                                                                                                            
                 
                  



                  getAuth(firebase).currentUser.getIdToken().then(token => {

                      var bodyInfo={
                          toEmail:this.state.email,
                          toName:this.state.name+" "+this.state.lastName, 
                          subject: ( (opt=="waiting_quotation")?"Votre devis" :(  (opt=="waiting_customer_payment")?"Réservation en attente de paiement":"Confirmation de réservation"  )  ), 
                          HTMLPart:list, 
                          replyToEmail:info.companyEmail,
                          replyToName:info.companyBrand,
                          token:token,

                          fromEmail:info.mavEmail,
                          fromName:info.companyBrand,
                          userID:getAuth(firebase).currentUser.uid,

                      }
                      this.firebaseSendByMail(bodyInfo)
                      if(opt!="waiting_quotation") {
                        this.state.params.updateAfterBook()
                        params.popToTop();
                      }
                      else this.alert.onAlert({title:strings.emailHasBeenSent, buttons:[{text: strings.ok,onPress: () => {this.state.params.updateAfterBook();params.popToTop();if(this.state.params.data.immediate!=true && this.state.taxiMode!=true && this.state.dispenser!=true && this.state.purposeReturn===true && opt!="requires_action" && opt!="waiting_bancontact" && opt!="waiting_customer_payment" && opt!="waiting_quotation" && this.state.endAddress!=undefined && this.state.endAddress!="" && this.state.purposeReturnAlready!=true)  this.state.params.purposeReturn();}},]})
                  })


                  
              }})
            }

          }



          if(opt=="waiting_quotation") {
            buttons[infoEmail].onPress();

          }
          else if(buttons.length==0){
            var messageError=((value!=false)? ( (Platform.OS=="web")?value: (strings.linkCopiedMessage+". ") ) :"")+    strings.errorEmail+". "+((Platform.OS!="web")?(strings.errorTelephone+". "):"" )+strings.contactClientYou;
            this.alert.onAlert({title:(value!=false)?strings.raceValidateLinkPayment:strings.raceHasBeenValidate, subTitle:messageError,buttons:[{text: strings.ok,onPress: () => {this.sendRaceInfoToFirebase(uuid, opt, sendToFirebase); this.state.params.updateAfterBook();params.popToTop();if(this.state.params.data.immediate!=true && this.state.taxiMode!=true && this.state.dispenser!=true && this.state.purposeReturn===true && opt!="requires_action" && opt!="waiting_bancontact" && opt!="waiting_customer_payment" && opt!="waiting_quotation" && this.state.endAddress!=undefined && this.state.endAddress!="" && this.state.purposeReturnAlready!=true)  this.state.params.purposeReturn();}},]})
          }
          else {

            buttons.push({text: strings.notPrevent,onPress: () => {this.sendRaceInfoToFirebase(uuid, opt, sendToFirebase); this.state.params.updateAfterBook();params.popToTop();if(this.state.params.data.immediate!=true && this.state.taxiMode!=true && this.state.dispenser!=true && this.state.purposeReturn===true && opt!="requires_action" && opt!="waiting_bancontact" && opt!="waiting_customer_payment" && opt!="waiting_quotation" && this.state.endAddress!=undefined && this.state.endAddress!="" && this.state.purposeReturnAlready!=true)  this.state.params.purposeReturn(); }})
            this.alert.onAlert({title:(Platform.OS=="web" && value!=false)?strings.raceValidateLinkPayment:strings.raceHasBeenValidate, subTitle:((value!=false)? ( (Platform.OS=="web")?value: (strings.linkCopiedMessage+". ") ) :"")+ strings.howContactCustomer,buttons:buttons})

          }


          

          

          



        }







  }



  sendRaceInfoToFirebase(uuid, opt, sendToFirebase){

    var linktoFB='raceWaitingStripe/' +uuid;
    if(opt=="waiting_customer_payment" || opt=="waiting_bancontact") linktoFB='raceWaitingStripe/' +uuid;
    else if(opt=="waiting_mypos") linktoFB='raceWaitingStripe/' +uuid;
    else if(opt=="waiting_quotation") linktoFB='raceWaitingQuotation/' +uuid;
    else if(opt!="requires_action") linktoFB='race/' +uuid;

    const fireInfo={} 
    fireInfo[linktoFB]=sendToFirebase; 
    update(ref(getDatabase(firebase)), fireInfo)

  }

  copyToClipboard(text){
  Clipboard.setString(text);

}


  sendWithSMS(message,phone){
    Linking.openURL("sms:"+((phone==undefined)?this.state.phone:phone)+((Platform.OS === 'ios')?"&":"?")+"body="+message)
  } 

  viewCard(){
      var selected=-1;
      var i;
      for(i=0;i<this.state.cardList.length;i++){
          if(this.state.cardList[i].id==this.state.cardSelected.id) selected=i;
      }
      this.alert.onAlert({title:strings.payment, items:this.state.cardList ,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {
        if(this.state.cardList[id].id==="addCard") this.setState({viewAddCard:true})
        else { this.setState({cardSelected:this.state.cardList[id]},() =>{this.calculateMajoration()}) }
       
      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  

  }


  viewPartner(){

    var selected=-1;
      var i;
      var listPartner=[];
      for(i=0;i<this.state.partnerList.length;i++){
         if(this.state.partnerList[i].favForbidden!=true || this.state.driver==true || this.state.partner==true) {
            if(this.state.partnerList[i].id==this.state.partnerSelected.id) selected=listPartner.length;
            listPartner.push(this.state.partnerList[i])
         }
      }


      this.alert.onAlert({title:((this.state.driver==true && this.state.forceDesired!=true && this.state.partnerSelected.id!=-1) || (this.state.partner==true && this.state.partnerSelected.id==getAuth(firebase).currentUser.uid) )?strings.attributedPartner: strings.desiredDriver,arrowQuestion:(this.state.driver==true)?strings.onlyDesired:undefined, arrowEnabled:this.state.forceDesired, items:listPartner ,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {
        if(this.state.driver==true && value.arrowQuestion!=undefined) this.setState({forceDesired:value.arrowQuestion})

        this.setState({partnerSelected:listPartner[id]})
       
      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  

  }
 




  changeAdressCustomer(rowData,key,type){
    const style=styleInfo();

    var itemsList=[];

    if(type=="start") itemsList.push({image:(style.mode=="dark")? require('../assets/favorite/pin_white.png')  :require('../assets/favorite/pin_black.png'), text:this.state.startAddress })
    var i;
    var itemSelected=(type=="end")?-1:((type=="start" && rowData.start!=undefined)?-1:0);
    var minSearch=0;
    var maxSearch=this.state.stopList.length;

    if((type=="start" && rowData.end!=undefined) || (type=="end" && rowData.start!=undefined) ) for(i=0;i<this.state.stopList.length;i++){
      
      if(type=="start"){
        if(this.state.stopList[i]==rowData.end) maxSearch=i; 
      }
      else{
        if(this.state.stopList[i]==rowData.start) minSearch=i+1; 
      }

    }


    
    
    for(i=minSearch;i<maxSearch;i++){
      if(type=="start" && this.state.stopList[i]==rowData.start) itemSelected=i+1;
      else if(type=="end" && this.state.stopList[i]==rowData.end) itemSelected=i-minSearch;
        itemsList.push({image:(style.mode=="dark")? require('../assets/favorite/pin_white.png')  :require('../assets/favorite/pin_black.png'), text:this.state.stopList[i] })
    }

    if(type=="end"){
      itemsList.push({image:(style.mode=="dark")? require('../assets/favorite/pin_white.png')  :require('../assets/favorite/pin_black.png'), text:this.state.endAddress })
      if(itemSelected==-1) itemSelected=itemsList.length-1;
    }

    if(itemsList.length>1) this.alert.onAlert({title:(type=="start")?strings.selectFrom:strings.selectTo, items:itemsList,itemSelected:itemSelected, buttons:[{text: strings.validate,onPress: (id,value) => {
      var passagersList=this.state.passagersList; 
      if(type=="start"){
          if(value==this.state.startAddress) delete passagersList[key].start
          else passagersList[key].start=value; 
      }
      else {
          if(value==this.state.endAddress) delete passagersList[key].end
          else passagersList[key].end=value; 
      }

      
      this.setState({passagersList:passagersList},() =>{this.saveBook() })

       }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  



  }

  componentWillUnmount(){
      /* waitingPromo*/

      if(this.state.waitingPartnerList==true) timer.clearTimeout("getPartner"); 
      if(this.state.waitingUserCard==true) timer.clearTimeout("getUserCards"); 
      if(this.state.waitingPromo==true) timer.clearTimeout("testPromoCode"); 

      if(this.state.waitGetPaymentURL==true) timer.clearTimeout("getPaymentURL"); 

      

  }

 

  componentDidMount() {

    var waitingPromo=false;
    var waitingUserCard=false;
    var waitingPartnerList=false;
    
    

    if(this.state.driver==true || this.state.partner==true || this.state.provider==true || this.state.customerPro==true) {
      this.setState({providerName: this.state.params.data.name,providerLastName:this.state.params.data.lastName,providerID:((this.state.customerPro==true)?undefined:getAuth(firebase).currentUser.uid),providerEnterprise:this.state.params.data.enterprise, providerAdressBill:this.state.params.data.adressBill,  providerCityBill:this.state.params.data.cityBill , providerEmail:this.state.params.data.email})
      if(this.state.provider==true || this.state.customerPro==true) {waitingPromo=true; this.testPromoCode(true);}
    }
    else {waitingPromo=true; this.testPromoCode(true);}

    if(info.paymentCardApp===true){
      if(this.state.driver!=true && this.state.partner!=true && this.state.dispenser!=true && this.state.provider!=true) {waitingUserCard=true; this.getUserCards();} 
      else if(this.state.dispenser==true){this.setState({cardSelected:{text:strings.paiementOnBoard,icon:require("../assets/paymentCash.png"),image:require("../assets/paymentCash.png"),onBoard:true,id:"onBoard"}, cardList:[{text:strings.paiementOnBoard,icon:require("../assets/paymentCash.png"),image:require("../assets/paymentCash.png"),onBoard:true,id:"onBoard"}]}) }
      else if(this.state.provider==true && this.state.privilegeProvider!="basic"){waitingUserCard=true; this.getUserCards();} 
      else {this.setState({cardSelected:{text:strings.paiementOnBoard,icon:require("../assets/paymentCash.png"),image:require("../assets/paymentCash.png"),onBoard:true,id:"onBoard"}, cardList:[{text:strings.paiementOnBoard,icon:require("../assets/paymentCash.png"),image:require("../assets/paymentCash.png"),onBoard:true,id:"onBoard"}]}) }
    }
    else {this.setState({cardSelected:{text:strings.paiementOnBoard,icon:require("../assets/paymentCash.png"),image:require("../assets/paymentCash.png"),onBoard:true,id:"onBoard"}, cardList:[{text:strings.paiementOnBoard,icon:require("../assets/paymentCash.png"),image:require("../assets/paymentCash.png"),onBoard:true,id:"onBoard"}]}) }
    
    if(this.state.params.data.kilometerMax>0) this.setState({kmLimit:(this.state.params.data.kilometerMax*(this.state.estimateTime/3600)).toFixed(0)})
    if(true || info.mavOffer=="multi") {waitingPartnerList=true; this.getPartnersList();}

    this.setState({waitingPromo:waitingPromo,waitingUserCard:waitingUserCard,waitingPartnerList:waitingPartnerList})

    this.calculateMajoration();



    if(Platform.OS!="web"){
      var doubtInfo={
        brand:DeviceInfo.getBrand(),
        model:DeviceInfo.getModel(), 
        date:this.state.integerDate,
      }
     
       DeviceInfo.getCarrier().then((name) => {
          if(name!="unknown") doubtInfo.carrier=name;
          DeviceInfo.getSerialNumber().then((name) => {
            if(name!="unknown") doubtInfo.serialNumber=name;
            DeviceInfo.getMacAddress().then((name) => {
               if(name!="02:00:00:00:00:00") doubtInfo.mac=name;
                DeviceInfo.getDeviceName().then((name) => {
                    if(name!="unknown") doubtInfo.deviceName=name;
                      
                       if(this.state.params.data.bookingOrderAdress!=undefined) doubtInfo.pos=this.state.params.data.bookingOrderAdress;
                       this.setState({doubtInfo:doubtInfo})
                      
                })
            })
          })
      })
    }

    else {
      var doubtInfo={
        brand:(navigator.userAgent.indexOf("Mac")!=-1)?"Apple Mac":((navigator.userAgent.indexOf("Windows")!=-1)?"Windows":"Linux"),
        model:"(web)", 
        date:this.state.integerDate,
      }

      if(this.state.params.data.bookingOrderAdress!=undefined) doubtInfo.pos=this.state.params.data.bookingOrderAdress;
      this.setState({doubtInfo:doubtInfo})


    }





    }




  


  calculateMajoration(){
      console.log("calculate majoration")

      var selectedOptionsArray=Object.keys(this.state.selectedOptions); 
      var amount=0
      var i;

      for(i=0; i<selectedOptionsArray.length;i++){

        if(this.state.selectedOptions[selectedOptionsArray[i]].price!=undefined && this.state.selectedOptions[selectedOptionsArray[i]].price>0){
          var nombre=(this.state.selectedOptions[selectedOptionsArray[i]].value==true)?1:this.state.selectedOptions[selectedOptionsArray[i]].value
          if(this.state.selectedOptions[selectedOptionsArray[i]].value!=false) amount+=(this.state.selectedOptions[selectedOptionsArray[i]].price* nombre )
        }

      }
      if(this.state.noVAT==true) amount/=(1+ ( (this.state.racePlaceEndName!=undefined)?info.tvaPercentDispo:info.tvaPercentClassic  ) /100)

      var estimateMajorationPassagers=(this.state.majoration.morethan!=undefined && this.state.passagerNumber>this.state.majoration.morethan)? ((this.state.majoration.passager!=undefined && this.state.extraEUMode!=true)? (  (this.state.localMajoration.passager!=undefined &&  this.state.localMajoration.passager > this.state.majoration.passager && this.state.localMajoration.morethan!=undefined && this.state.passagerNumber>this.state.localMajoration.morethan)?  this.state.localMajoration.passager   :  this.state.majoration.passager    ) : this.state.localMajoration.passager)      :0
      if(estimateMajorationPassagers==undefined) estimateMajorationPassagers=0;
      if(estimateMajorationPassagers>0) estimateMajorationPassagers=(this.state.passagerNumber-this.state.majoration.morethan)*estimateMajorationPassagers;
      if(this.state.noVAT==true) estimateMajorationPassagers/=(1+ ( (this.state.racePlaceEndName!=undefined)?info.tvaPercentDispo:info.tvaPercentClassic  ) /100)





      var esPg=this.state.estimatePriceGo;
      esPg.realPrice.option=amount
      
      

      var percentReduc=(this.state.promo.codeReduc!=undefined && this.state.promo.amount!=true)?this.state.promo.codeReduc/100:0;
      var promoName=(this.state.promo.codeName!=undefined  )?this.state.promo.codeName:"";
      var promoID=(this.state.promo.codeID!=undefined  )?this.state.promo.codeID:"";
      var fixeReduc=(this.state.promo.codeReduc!=undefined && this.state.promo.amount==true)?this.state.promo.codeReduc:0;
      if(this.state.noVAT==true) fixeReduc/=(1+ ( (this.state.racePlaceEndName!=undefined)?info.tvaPercentDispo:info.tvaPercentClassic  ) /100)

      var precision=(this.state.params.data.pricingPrecise==true)?100:1

        if(esPg.realPrice.priceBasic1!=undefined){
          esPg.realPrice.priceTotal1=esPg.realPrice.priceBasic1;
          esPg.realPrice.priceTotal2=esPg.realPrice.priceBasic2;
          if(this.state.taxiMode==true && this.state.goReturnTaxi==true){
            esPg.realPrice.priceTotal1=esPg.realPriceIfReturn.priceBasic1;
            esPg.realPrice.priceTotal2=esPg.realPriceIfReturn.priceBasic2;
          
          }
 
          if(this.state.taxiMode!=true && esPg.realPrice.majorationRealTime1!=undefined && esPg.realPrice.majorationRealTime1>0){esPg.realPrice.priceTotal1+=esPg.realPrice.majorationRealTime1;esPg.realPrice.priceTotal2+=esPg.realPrice.majorationRealTime2; esPg.realPrice.majorationRealTime=(esPg.realPrice.majorationRealTime1!=esPg.realPrice.majorationRealTime2)?(esPg.realPrice.majorationRealTime1+"-"+esPg.realPrice.majorationRealTime2):esPg.realPrice.majorationRealTime1   }
          if(this.state.taxiMode!=true && esPg.realPrice.majorationDate1!=undefined && esPg.realPrice.majorationDate1.amount>0){esPg.realPrice.priceTotal1+=esPg.realPrice.majorationDate1.amount;esPg.realPrice.priceTotal2+=esPg.realPrice.majorationDate2.amount;}
          
          esPg.realPrice.priceTotal1+=amount+estimateMajorationPassagers
          if(this.state.taxiMode!=true) esPg.realPrice.priceTotal1+=(esPg.realPrice.lastMinute1+esPg.realPrice.avanceOrder1)
          esPg.realPrice.priceTotal2+=amount +estimateMajorationPassagers 
          if(this.state.taxiMode!=true) esPg.realPrice.priceTotal2+=(esPg.realPrice.lastMinute2+esPg.realPrice.avanceOrder2)

          if(this.state.taxiMode!=true){
              var reduction1=(Math.round( (esPg.realPrice.priceTotal1*percentReduc) *precision)/precision) +fixeReduc
              var reduction2=(Math.round( (esPg.realPrice.priceTotal2*percentReduc) *precision)/precision) +fixeReduc

              if(percentReduc>0 || fixeReduc>0) {
                    esPg.realPrice.promo={name:promoName, id:promoID, amount:((reduction1!=reduction2)?(reduction1+"-"+reduction2):reduction1), percent:percentReduc, fixe:fixeReduc}
                    esPg.realPrice.priceTotal1-=reduction1
                    esPg.realPrice.priceTotal2-=reduction2
                }
                else esPg.realPrice.promo={amount:0}
          } else esPg.realPrice.promo={amount:0}


          esPg.realPrice.priceTotal1=(Math.round( esPg.realPrice.priceTotal1 *precision)/precision)
          esPg.realPrice.priceTotal2=(Math.round( esPg.realPrice.priceTotal2 *precision)/precision)

          if(esPg.provCom!=undefined && this.state.deferredPayment!=true && this.state.cardSelected.onBoard===true) {
            esPg.realPrice.priceTotal1+=esPg.provCom;
            esPg.realPrice.priceTotal2+=esPg.provCom;  
          }

          if(this.state.multipleCar>1){
            esPg.realPrice.priceTotal1*=this.state.multipleCar;
            esPg.realPrice.priceTotal2*=this.state.multipleCar;
          }

          esPg.realPrice.priceTotal=esPg.realPrice.priceTotal1+"-"+esPg.realPrice.priceTotal2;


        }
        else{

            esPg.realPrice.priceTotal=esPg.realPrice.priceBasic;
            if(this.state.taxiMode==true && this.state.goReturnTaxi==true){esPg.realPrice.priceTotal=esPg.realPriceIfReturn.priceBasic; }

            if(this.state.taxiMode!=true && esPg.realPrice.majorationRealTime!=undefined && esPg.realPrice.majorationRealTime>0) esPg.realPrice.priceTotal+=esPg.realPrice.majorationRealTime;
            if(this.state.taxiMode!=true && esPg.realPrice.majorationDate!=undefined && esPg.realPrice.majorationDate.amount>0) esPg.realPrice.priceTotal+=esPg.realPrice.majorationDate.amount;
            
            esPg.realPrice.priceTotal+=amount+estimateMajorationPassagers
            if(this.state.taxiMode!=true) esPg.realPrice.priceTotal+=(esPg.realPrice.lastMinute+esPg.realPrice.avanceOrder)
            
           

            var reduction=(Math.round( (esPg.realPrice.priceTotal*percentReduc) *precision)/precision) + fixeReduc

            if(this.state.taxiMode!=true && (percentReduc>0 || fixeReduc>0) ) {
                esPg.realPrice.promo={name:promoName, id:promoID, amount:reduction, percent:percentReduc, fixe:fixeReduc}
                esPg.realPrice.priceTotal-=reduction
            }
            else esPg.realPrice.promo={amount:0}
            console.log(this.state.cardSelected)

            if(esPg.provCom!=undefined) {
              esPg.realPrice.priceTotalWithProvCom=esPg.realPrice.priceTotal+esPg.provCom;
              esPg.realPrice.priceTotalWithProvCom=(Math.round( esPg.realPrice.priceTotalWithProvCom *precision)/precision)

            }

            if(esPg.provCom!=undefined && !(this.state.deferredPayment==true ||  this.state.cardSelected.onBoard!=true) ) {
              esPg.realPrice.priceTotal+=esPg.provCom;
            }

            if(this.state.multipleCar>1) esPg.realPrice.priceTotal*=this.state.multipleCar;
            
            esPg.realPrice.priceTotal=(Math.round( esPg.realPrice.priceTotal *precision)/precision)


        }
        






      this.setState({estimatePriceGo:esPg})

      

      /*
    Il y a 3 paramètres à prendre en compte 
    - Siege auto 
    - réhausseur
    - Le code promo
    */

  }

  testPromoCode(start){
    console.log("testPromoCode start")
    if(start!=undefined){

          var bodyPromo={
            uuid:(start==true)?getAuth(firebase).currentUser.uid:start,
            version:info.appliVersion
          }


          console.log(" fetch testPermanentPromoCodeAndDeferredPayment")
          fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/testPermanentPromoCodeAndDeferredPayment", {
            body: JSON.stringify(bodyPromo),
            headers: {"Content-Type": "application/json"},method: "POST"}).then((response) => response.json())
                      .then((responseJson) => {
                        
                        var res=responseJson;

                        var st={}; 
                        console.log(res)
                        if(res.ip!=undefined && this.state.doubtInfo!=undefined) {
                            var dtInfo=JSON.parse(JSON.stringify(this.state.doubtInfo)); 
                            dtInfo.ip=res.ip
                            this.setState({doubtInfo:dtInfo})
                            console.log(dtInfo)
                        }

                        if(res.result==true) st={promoCode:res.codeName, promo:res}; 
                        else  st={promoCode:"", promo:{} };

                        if(res.deferredPayment!=undefined && res.deferredPayment==true && this.state.dispenser!=true) st.deferredPayment=true; 
                        if(this.state.provider===true && res.providerCommission!=undefined) st.providerCommission=res.providerCommission;
                        st.waitingPromo=false

                        this.setState(st,()=>{this.saveBook(); timer.setTimeout("calculateMajorationDef", () => {this.calculateMajoration() },300) } ); 

            }).catch((err) => { console.log("error testPromoCode"); console.log(err); timer.setTimeout("testPromoCode", () => { this.testPromoCode(start);  }, 2000);   })

    }
    else if(this.state.promoCode!="" && this.state.promoCode!=this.state.promo.codeName){

        var bod={
          promoCode:this.state.promoCode,
          uuid:getAuth(firebase).currentUser.uid,
          price:(this.state.estimatePriceGo.realPrice.priceTotal1!=undefined)?this.state.estimatePriceGo.realPrice.priceTotal1:this.state.estimatePriceGo.realPrice.priceTotal,  
        }

        if(this.state.money.id!="eu") bod.moneyID=this.state.money.id
        if(this.state.endAddress=="" || this.state.endAddress==undefined) bod.pv=true

        if(this.state.endAddress!="" && this.state.destinationID!="") bod.destinationID=this.state.destinationID;
        


        console.log(bod)
        console.log(" fetch promoCode")
        fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/testPromoCode", {
        body: JSON.stringify(bod),
        headers: {"Content-Type": "application/json"},method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {
          var res=responseJson
           console.log("res")
            console.log(res)

          if(res.result==true){
            this.setState({ promo:res },()=>this.calculateMajoration()); 
          }
          else {
            this.setState({promo:{} },()=>this.calculateMajoration()); 

            if(res.why=="errorDate") this.alert.onAlert({title:strings.promoCodeInvalidDate}) 
            else if(res.why=="errorDestinationID") this.alert.onAlert({title:strings.promoCodeInvalidDest}) 
            else if(res.why=="notGoodPrice") this.alert.onAlert({title:strings.promoCodeInvalidPrice +" "+ ((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+res.codeFrom+((this.state.money.position=="right")?(this.state.money.symbole):"") }) 
            else if(res.why=="alreadyUse") this.alert.onAlert({title:strings.promoCodeInvalidUse}) 
            else this.alert.onAlert({title:strings.promoCodeInvalid}) 

        }
          
        }).catch((err) => { console.log("error testPromoCode"); console.log(err); timer.setTimeout("testPromoCode", () => { this.testPromoCode(start);  }, 2000);   })
      }
      else {this.setState({promoCode:"",promo:{} },()=>this.calculateMajoration()) }


  }

  


  updatePartnersList(){


    var addOk;
    var partnerList=[];
    var i;
    for(i=0;i<this.state.partnerListTotal.length;i++){
      addOk=false;
      if(this.state.partnerListTotal[i].id==-1) addOk=true;
      else if(this.state.partnerListTotal[i].noLanguage[strings.idLangue]!=true &&  ( (this.state.childSeats==false || this.state.partnerListTotal[i].acceptedOptions.childSeats==true) && (this.state.boosterSeats==false || this.state.partnerListTotal[i].acceptedOptions.boosterSeats==true) &&  (this.state.wheelchair==false || this.state.partnerListTotal[i].acceptedOptions.wheelchair==true)  && (this.state.animal==false || this.state.partnerListTotal[i].acceptedOptions.animal==true)    )) addOk=true;
      
      if(addOk==true) partnerList.push(this.state.partnerListTotal[i])
      else if( this.state.partnerSelected.id!=getAuth(firebase).currentUser.uid  && this.state.partnerSelected.id==this.state.partnerListTotal[i].id ) this.setState({partnerSelected:{id:-1,text:strings.noMatter} }  )

    }

    this.setState({partnerList:partnerList})





  }


  getPartnersList(){
    var rqPart={
        carName:this.state.carName,
        uuid:getAuth(firebase).currentUser.uid,
    }

    
    if(this.state.unavailableIfRace===true) rqPart.unavailableIfRace=true;
    if(this.state.noZone!="") rqPart.noZone=this.state.noZone;
    if( this.state.driver==false && this.state.partner==false && this.state.params.data.vipMode==true && this.state.params.data.vip==true) rqPart.vip=true; 
    if(this.state.enableOrderDriver==true) rqPart.orderDriver=true; 
 
    console.log("je test les partneer "+ Object.keys(rqPart))
    console.log("orderDriver = "+rqPart.orderDriver)

    console.log(" fetch getPartner")
    fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/getPartner", {
        body: JSON.stringify(rqPart),
        headers: {"Content-Type": "application/json"},method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {
                    console.log("partner")
                    console.log(responseJson)
                    this.setState({waitingPartnerList:false,})
                    var res=responseJson
                    var res2=[{id:-1,text:strings.noMatter}]
                    var addOk;
                    var compatibleWithThisRace=false;
                    var partnerSelected="";
                    var i,j;
                    for(i=0;i<res.length;i++){ 
                      addOk=true;
                      for(j=0;j<this.state.blackList.length;j++){
                        if(res[i].id==this.state.blackList[j].id) addOk=false;
                        if( (this.state.partner==true || this.state.driver==true) && res[i].id===getAuth(firebase).currentUser.uid ) compatibleWithThisRace=true
                      }

                      if(addOk==true){
                        res2.push(res[i]);
                        if(res[i].id==this.state.favoriteDriver.id && res[i].id!=-1) partnerSelected=res[i] 
                      }

                    }


                    if(compatibleWithThisRace==false && (this.state.partner==true || this.state.driver==true) && info.mavOffer=="multi"  ){ this.setState({forceViewPartner:true});  } 
                    if((this.state.partner==true || this.state.driver==true) && this.state.params.data.adminNotRace!=true && this.state.manager!=true && this.state.providerName!=undefined) this.setState({partnerSelected:{id:getAuth(firebase).currentUser.uid,text:this.state.providerName+" "+this.state.providerLastName}    })

                    if(partnerSelected!="") this.setState({partnerSelected:partnerSelected})
                      console.log("partnerList=")
                    console.log(res2); 
                    this.setState(() => ({partnerList:res2,partnerListTotal:res2 }),function(){ this.updatePartnersList() })

                    
        }).catch((err) => { console.log("error getPartner"); console.log(err); timer.setTimeout("getPartner", () => { this.getPartnersList();  }, 2000);   })
    }


  changeSelectedOptions= (name, value, price) => {
    var selectedOptions=this.state.selectedOptions;
    if(selectedOptions==undefined) selectedOptions={}
    if(selectedOptions[name]==undefined) selectedOptions[name]={}
    selectedOptions[name]={value:value, price:price}; 
  console.log(selectedOptions)

    this.setState({selectedOptions:selectedOptions, change:true},() =>{this.calculateMajoration(); this.updatePartnersList(); })

  }

  changeBillOptionForMaxDriver(){

      var selected=-1;
      var i;
      for(i=0;i<strings.BillOptionForMaxDriver.length;i++){
            if(strings.BillOptionForMaxDriver[i].id==this.state.paymentDriverMode) selected=i;
      }


      this.alert.onAlert({title:strings.infoBill, items:strings.BillOptionForMaxDriver ,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {
         this.setState({paymentDriverMode:strings.BillOptionForMaxDriver[parseInt(id)].id, paymentDriverModeTxt:value}) 
      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  



  }

  changeAmountDriver(){
              if(this.state.waiting==false){
                if(this.state.forceDriverPrice==false){
                   this.alert.onAlert({title:strings.forceDriverPrice, subTitle:strings.forceDriverPriceInfo , textInput:{placeholder:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"20"+((this.state.money.position=="right")?(this.state.money.symbole):""),text:this.state.forceDriverPriceAmount.toString(),sizeMultiplicator:2,detectSequencePosition:this.state.money.position,detectSequence:this.state.money.symbole,keyboardType:"numeric"},buttons:[
                      {text: strings.validate,onPress: (value) => {
                       
                        value=value.toString().replace(this.state.money.symbole,'')
                        value=parseFloat(value);
                        var precision=(this.state.params.data.pricingPrecise===true)?100:1;
                        value=Math.round(value*precision)/precision
                        if(value.toString()!="NaN" ) this.setState({forceDriverPrice:true, forceDriverPriceAmount:value})

                        

                      }},
                      {text: strings.cancel, style:"cancel",onPress: () => {}}
                      ],})
                }
                else this.setState({forceDriverPrice:false})
                }

  }


  createAccountQuestion(){
    this.alert.onAlert({title:strings.createAccount, subTitle:strings.createAccountFromBook ,buttons:[ 
      {text: strings.yes,onPress: (value) => {
          var uuid=generateUUID();

          var newClient={
            name:this.state.name,
            lastName:this.state.lastName,
            manualClient:true,
          }

          if(this.state.enterprise!=undefined && this.state.enterprise!="") newClient.enterprise=this.state.enterprise
          if(this.state.phone!=undefined && this.state.phone!="") newClient.phone=this.state.phone
          if(this.state.adressBill!=undefined && this.state.adressBill!="") newClient.adressBill=this.state.adressBill
          if(this.state.cityBill!=undefined && this.state.cityBill!="") newClient.cityBill=this.state.cityBill
          
          const fireInfo={} 
          fireInfo["/users/"+uuid]=newClient; 
          update(ref(getDatabase(firebase)), fireInfo)
          
          this.setState({clientID:uuid})
          this.chooseName.resetSuggestions()
          this.chooseEnterprise.resetSuggestions()
          this.chooseLastName.resetSuggestions()
          this.alert.onAlert({title:strings.addClientOK});


           

      }},
      {text: strings.cancel, style:"cancel",onPress: () => {}}]

    })
  }






  render() {
    var text="";
    let moneyListTotal=moneyList
    if(this.state.params.data.viewAccurency==true && Object.keys(this.state.params.data.viewAccurencyRates).length>0){
      var listConv=Object.keys(this.state.params.data.viewAccurencyList);
      var precision=(this.state.params.data.pricingPrecise===true)?100:1;
      var i; 
      for(i=0;i<listConv.length;i++){
        if(listConv[i]!=this.state.money.id){
          var j=0
          while( ! (moneyListTotal[j].id==listConv[i] || j==moneyListTotal.length-1) ) j++;

            var price=this.state.estimatePriceGo.realPrice.priceTotal;
            if(this.state.taxiMode==true) {price=this.state.estimatePriceGo.realPrice.priceTotal}



            var search= price.toString().indexOf("-");
            if(search!=-1){
              var price1=parseFloat(price.substring(0,search))
              var price2=parseFloat(price.substring(search+1,price.length))

              if(this.state.money.id!="eu") {
                price1/=this.state.params.data.viewAccurencyRates[(this.state.money.stripeCode).toUpperCase()];
                price2/=this.state.params.data.viewAccurencyRates[(this.state.money.stripeCode).toUpperCase()];
              }

            }
            else if(this.state.money.id!="eu") price/=this.state.params.data.viewAccurencyRates[(this.state.money.stripeCode).toUpperCase()];
              


            if(moneyListTotal[j].id==listConv[i]){
                if(search!=-1){
                  if(moneyListTotal[j].stripeCode.toUpperCase()!="EUR") price1*=this.state.params.data.viewAccurencyRates[(moneyListTotal[j].stripeCode).toUpperCase()];
                  price1=Math.round(price1*precision)/precision
                  if(moneyListTotal[j].stripeCode.toUpperCase()!="EUR") price2*=this.state.params.data.viewAccurencyRates[(moneyListTotal[j].stripeCode).toUpperCase()];
                  price2=Math.round(price2*precision)/precision
                  if(text!="") text+=" | "
                  text+=((moneyListTotal[j].position=="left")?(moneyListTotal[j].symbole+" "):"")+price1+"-"+price2+((moneyListTotal[j].position=="right")?(moneyListTotal[j].symbole):"")
                
                  
                }
                else {
                  var priceMonnaie=price;
                  if(moneyListTotal[j].stripeCode.toUpperCase()!="EUR") priceMonnaie*=this.state.params.data.viewAccurencyRates[(moneyListTotal[j].stripeCode).toUpperCase()];
                  priceMonnaie=Math.round(priceMonnaie*precision)/precision
                  if(text!="") text+=" | "
                  text+=((moneyListTotal[j].position=="left")?(moneyListTotal[j].symbole+" "):"")+priceMonnaie+((moneyListTotal[j].position=="right")?(moneyListTotal[j].symbole):"")
                }
          }
          



          
        }
      }
    }
    
    let convertPrice=text



    return (
      <StyleContext.Consumer>{style => 
      <View style={{ width:"100%", height:"100%"}} >

      {(Platform.OS=="web" || Dimensions.get('window').width>style.mobileSizeMax || this.state.dispenser==true ) && <MavNavigationMinimize maxiMode={this.state.dispenser} clickLeft={() => { var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params; params.goBack();  }} left={strings.return} title={ strings.finalizeOrder } />}


      <KeyboardAwareScrollView extraHeight={100} innerRef={ref => {this.scroll = ref}} scrollEnabled={true} style={{ flex: 1, backgroundColor: style.backgroundColor }}>
             

       
        {(this.state.driver==true || this.state.partner==true || this.state.provider==true || this.state.customerPro==true) && <TextPresentation maxiMode={this.state.dispenser} editable={false} onEditClick={()=>{ this.setState({viewClientDetail:!this.state.viewClientDetail}) }}   viewEdit={true} text={ (this.state.name!="" && this.state.lastName!="")?(this.state.name+" "+this.state.lastName):strings.principalCustomer } textExplication={strings.bookingOf} icon={(style.mode=="dark")?require('../assets/user_white.png'):require('../assets/user_black.png')} 
            elementRight={(this.state.viewClientDetail==true && this.state.dispenser!=true)?<View style={{flexDirection:"row"}}>
                      {((this.state.dispenser!=true && this.state.passagers!=undefined && this.state.passagers>1 && this.state.passagersList.length<this.state.passagers-1) && this.state.addClientBook==true) && <MavMiniButton  minimize={true} icon={(style.mode=="dark")?require('../assets/plus_black.png'):require('../assets/plus_white.png')} text={strings.add} onlyButton={true} style={{marginRight:10}} onPress={()=>{ var passagersList=this.state.passagersList; if(passagersList==undefined) passagersList=[]; passagersList.push({name:"", lastName:""}); this.setState({passagersList:passagersList, passagerNumber:this.state.passagerNumber+1 })   }} />}
                      <MavMiniButton  minimize={true} icon={(style.mode=="dark")?require('../assets/close_black.png'):require('../assets/close_white.png')} text={strings.close} onlyButton={true}  onPress={()=>{ this.setState({viewClientDetail:false})  }} />
        </View>:undefined}            
        />}

        {((this.state.driver==true || this.state.partner==true || this.state.provider==true || this.state.customerPro==true) && this.state.viewClientDetail==true) && <TextPresentation hideTopbar={(this.state.passagersList.length>0)?false:true} style={{marginLeft:(this.state.passagersList.length>0)?"5%":undefined, marginRight:(this.state.passagersList.length>0)?"5%":undefined}} maxiMode={this.state.dispenser}  defautVisible={true} text={ (this.state.name!="" && this.state.lastName!="")?(this.state.name+" "+this.state.lastName):strings.principalCustomer } icon={(style.mode=="dark")?require('../assets/user_white.png'):require('../assets/user_black.png')} >

              {(this.state.dispenser!=true && this.state.orderFor==true && (this.state.driver==true || (this.state.manager==true && this.state.managerPhonebookOk==true)) ) && <TextPresentation  editable={false} maxiMode={this.state.dispenser} style={{marginTop:5}}  text={(this.state.orderForInfo==true)?(((this.state.providerEnterprise!=undefined && this.state.providerEnterprise!="")?this.state.providerEnterprise:(this.state.providerName+" "+this.state.providerLastName))):strings.selectProviderAffaire} textExplication={strings.orderFor} viewEdit={true} onEditClick={() => {
                      this.setState({onClientSelectedPassager:"false"})
                      if (this.state.waiting==false) {
                        var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params;
                        params.navigate('Clients', {selectClient: true, selectOnlyPro:true, onClientSelected: this.onClientSelected, driver:this.state.driver })
                        timer.setTimeout("timer", () => {this.setState({waiting:false})}, 2000);
                      }
              }}
                />}



              <TextPresentation ref={chooseName => {this.chooseName = chooseName;}} suggestions={(this.state.dispenser!=true && (this.state.manager==false || this.state.managerPhonebookOk==true) )?"name":undefined} driverMode={this.state.driver} maxiMode={this.state.dispenser} style={{marginTop:(this.state.dispenser!=true && (this.state.manager==false || this.state.managerPhonebookOk==true) )?0:5}}  text={this.state.name} textExplication={strings.name} placeholder={example.name} 
              onSuggestion={(value)=>{ value.noClientPassager=true; this.onClientSelected(value)}}
              onChangeText={(text)=>{this.setState({name:text},() =>{this.saveBook() })   }}
                  elementRight={(this.state.dispenser!=true && (this.state.manager==false || this.state.managerPhonebookOk==true) )? <View style={{flexDirection:"row"}}>
                   
                  {(this.state.dispenser!=true && this.state.driver==true && this.state.name!="" && this.state.lastName!="" && (this.state.clientID==undefined || this.state.clientID=="" )) && 
                  <MavMiniButton style={{marginRight:7}} minimize={true} icon={(style.mode=="dark")?require('../assets/plus_black.png'):require('../assets/plus_white.png')} text={strings.createAccount} onlyButton={true}  onPress={()=>{ this.createAccountQuestion()  }} />}

                   <MavMiniButton  minimize={true} icon={(style.mode=="dark")?require('../assets/phoneBook_black.png'):require('../assets/phoneBook_white.png')} text={strings.preFill} onlyButton={true}  onPress={()=>{ 
                      this.setState({onClientSelectedPassager:"false"})
                      if (this.state.waiting==false) {
                        var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params;
                        params.navigate('Clients', {selectClient: true, onClientSelected: this.onClientSelected, driver:this.state.driver })
                        timer.setTimeout("timer", () => {this.setState({waiting:false})}, 2000);
                      }
                   }} /> 
                   </View> :undefined }

              />

              <TextPresentation maxiMode={this.state.dispenser} style={{marginTop:(this.state.dispenser!=true && (this.state.manager==false || this.state.managerPhonebookOk==true) )?-5:5}}  text={this.state.lastName} textExplication={strings.lastName}  placeholder={example.lastName} onChangeText={(text)=>{this.setState({lastName:text},() =>{this.saveBook() })   }}
              ref={chooseLastName => {this.chooseLastName = chooseLastName;}}
              suggestions={(this.state.dispenser!=true && (this.state.manager==false || this.state.managerPhonebookOk==true) )?"lastName":undefined} driverMode={this.state.driver}
              onSuggestion={(value)=>{ value.noClientPassager=true; this.onClientSelected(value)}}

              />

              {(this.state.dispenser!=true) && <TextPresentation maxiMode={this.state.dispenser} style={{marginTop:5}} suggestions={(info.countryCode=="fr")?"enterprise":undefined}  ref={chooseEnterprise => {this.chooseEnterprise = chooseEnterprise;}} text={this.state.enterprise} textExplication={strings.enterprise} onSuggestion={(value)=>{ this.setState({enterprise: value.name })}}  placeholder={example.company} onChangeText={(text)=>{this.setState({enterprise:text},() =>{this.saveBook() })  }}/>}


              <TextPresentation maxiMode={this.state.dispenser} disableLine={(this.state.dispenser==true)} style={{marginTop:5}}  text={this.state.phone} keyboardType={"numeric"} textExplication={strings.phone}  placeholder={example.phone} onChangeText={(text)=>{this.setState({phone:text},() =>{this.saveBook() })  }}/>


              {(this.state.dispenser!=true) && <TextPresentation maxiMode={this.state.dispenser} style={{marginTop:5}}  text={(this.state.email==undefined)?"":this.state.email} textExplication={strings.email}  placeholder={example.email} onChangeText={(text)=>{this.setState({email:text},() =>{this.saveBook() })  }}/>}

              




        </TextPresentation>}

        {this.state.passagersList.map((rowData, key) => (<View>

            <TextPresentation  style={{marginLeft:"5%", marginRight:"5%", marginTop:5}}  text={ (this.state.passagers==undefined || (key+2)>this.state.passagers)?strings.passagerToHigh.toUpperCase(): (  (rowData.name!="" && rowData.lastName!="")?(rowData.name+" "+rowData.lastName):(strings.traveler+" "+(key+2)) ) } icon={(style.mode=="dark")?require('../assets/user_white.png'):require('../assets/user_black.png')} >

                    <TextPresentation style={{marginTop:0}} text={rowData.name} textExplication={strings.name} placeholder={example.name} onChangeText={(text)=>{var passagersList=this.state.passagersList; passagersList[key].name=text;      this.setState({passagersList:passagersList},() =>{this.saveBook() })   }}
                      suggestions={(this.state.dispenser!=true && (this.state.manager==false || this.state.managerPhonebookOk==true) )?"name":undefined} driverMode={this.state.driver}  onSuggestion={(value)=>{this.setState({onClientSelectedPassager:key},() =>{this.onClientSelected(value) })    }}
                      elementRight={(this.state.driver==true || this.state.partner==true || this.state.provider==true)?<MavMiniButton  minimize={true} icon={(style.mode=="dark")?require('../assets/phoneBook_black.png'):require('../assets/phoneBook_white.png')} text={strings.preFill} onlyButton={true}  onPress={()=>{ 
                            this.setState({onClientSelectedPassager:key})
                            if (this.state.waiting==false) {
                               var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params;
                                params.navigate('Clients', {selectClient: true, onClientSelected: this.onClientSelected, driver:this.state.driver })
                                timer.setTimeout("timer", () => {this.setState({waiting:false})}, 2000);
                            }
                         }} />:undefined }


                    />
                    <TextPresentation suggestions={(this.state.dispenser!=true && (this.state.manager==false || this.state.managerPhonebookOk==true) )?"lastName":undefined} driverMode={this.state.driver}  onSuggestion={(value)=>{this.setState({onClientSelectedPassager:key},() =>{this.onClientSelected(value) })    }} style={{marginTop:(this.state.driver==true || this.state.partner==true || this.state.provider==true)?-5:5}} text={rowData.lastName} textExplication={strings.lastName}   placeholder={example.lastName} onChangeText={(text)=>{var passagersList=this.state.passagersList; passagersList[key].lastName=text;      this.setState({passagersList:passagersList},() =>{this.saveBook() })   }}/>
                    <TextPresentation style={{marginTop:5}} text={(rowData.phone!=undefined)?rowData.phone:""} keyboardType={"numeric"} textExplication={strings.phone}  placeholder={example.phone} onChangeText={(text)=>{var passagersList=this.state.passagersList; passagersList[key].phone=text;      this.setState({passagersList:passagersList},() =>{this.saveBook() })   }}/>


                    {(this.state.stopList!=undefined && this.state.stopList.length>0) && <View style={{marginLeft:"5%", marginRight:"5%", marginTop:15, marginBottom:15}}>

                        <RaceTrajetInfo 
                            racePlaceEndName={(rowData.end!=undefined)?rowData.end:this.state.endAddress  } 
                            clickOnFrom={() => {this.changeAdressCustomer(rowData,key,"start"); }}
                            clickOnTo ={() => {this.changeAdressCustomer(rowData,key,"end"); }}
                            racePlaceStartName={(rowData.start!=undefined)?rowData.start:this.state.startAddress}  />
                            
                    </View>}

                    <View style={{width:"100%", alignItems:"center", justifyContent:"center", marginTop:5}}> 
                        <MavButton onlyButton={true} small={true} text={strings.remove} style={{marginRight:5}} onPress={()=>{ var nb=this.state.passagerNumber-1; var passagersList=this.state.passagersList; passagersList.splice(key, 1);      this.setState({passagersList:passagersList, passagerNumber:nb},() =>{ this.calculateMajoration(); this.saveBook() }) }}/>
                    </View>   

            </TextPresentation>


          </View>
            

        ))}


      {this.state.viewRoomHotel==true && <TextPresentation icon={(style.mode=="dark")?require('../assets/favorite/bed_white.png'):require('../assets/favorite/bed_black.png')} maxiMode={this.state.dispenser} style={{marginTop:5}} textInputFlex={1} text={this.state.roomHotel} textExplication={strings.roomHotel} placeholder={"Ex : 201"}  onChangeText={(text)=>{this.setState({roomHotel:text}) }}/>}

      < ManageOptions maxiMode={this.state.dispenser} defautVisible={!(((this.state.driver==true || this.state.partner==true || this.state.provider==true || this.state.customerPro==true) && this.state.viewClientDetail==true) || this.state.viewFlightTrain!=false) } listOption={{
          childSeats:this.state.params.data.childSeats,boosterSeats:this.state.params.data.boosterSeats,animal:this.state.params.data.animal,wheelchair:this.state.params.data.wheelchair,optionalOrder:this.state.availableListOption,
          priceChildSeats:((this.state.majoration.childSeats!=undefined && this.state.extraEUMode!=true)? (  (this.state.localMajoration.childSeats!=undefined &&  this.state.localMajoration.childSeats > this.state.majoration.childSeats)?  this.state.localMajoration.childSeats   :  this.state.majoration.childSeats    ) : this.state.localMajoration.childSeats), 
          priceBoosterSeats:((this.state.majoration.boosterSeats!=undefined && this.state.extraEUMode!=true)? (  (this.state.localMajoration.boosterSeats!=undefined &&  this.state.localMajoration.boosterSeats > this.state.majoration.boosterSeats)?  this.state.localMajoration.boosterSeats   :  this.state.majoration.boosterSeats    ) : this.state.localMajoration.boosterSeats), 
          priceWheelchair:((this.state.majoration.wheelchair!=undefined && this.state.extraEUMode!=true)? (  (this.state.localMajoration.wheelchair!=undefined &&  this.state.localMajoration.wheelchair > this.state.majoration.wheelchair)?  this.state.localMajoration.wheelchair   :  this.state.majoration.wheelchair    ) : this.state.localMajoration.wheelchair),
          priceAnimal:((this.state.majoration.animal!=undefined && this.state.extraEUMode!=true)? (  (this.state.localMajoration.animal!=undefined &&  this.state.localMajoration.animal > this.state.majoration.animal)?  this.state.localMajoration.animal   :  this.state.majoration.animal    ) : this.state.localMajoration.animal), luggageMax:(this.state.params.data.luggageOption===true)?((this.state.luggageMax!=undefined)?this.state.luggageMax:5):undefined,
        }}
        money={this.state.money}  selectedOptions={this.state.selectedOptions} onSelectedOption={(name, value, price)=>{ this.changeSelectedOptions(name,value, price);  }}  style={{marginTop:5}} />


        {(this.state.addClientBook!=true && this.state.dispenser!=true && this.state.passagers!=undefined && this.state.passagers>1) && <TextPresentation selectedQuantity={this.state.passagerNumber} onChangeQuantity={(quantity)=>{ var cptresult=this.state.passagerNumber;  if(quantity==-1 && (this.state.passagerNumber>this.state.passagersMin)) cptresult--; else if(quantity!=-1 && this.state.passagerNumber<(this.state.passagers)) cptresult++; this.setState({passagerNumber:cptresult }) }}  textMini={this.state.passagers+" "+strings.maxPassagers} text={strings.morePassager } editable={false}   />}

        {(this.state.endAddress=="" && this.state.params.data.multipleCarProvision==true) && <TextPresentation icon={(style.mode=="light")?require('../assets/car_x_black.png'):require('../assets/car_x_white.png')} style={{marginTop:5}} textMini={strings.orderMultiCar}  text={((this.state.multipleCar<2)?strings.car:strings.cars)} editable={false} selectedQuantity={this.state.multipleCar}  onChangeQuantity={(quantity)=>{ var multipleCar=this.state.multipleCar; if(quantity==-1) multipleCar-=1; else multipleCar+=1; if(multipleCar<1) multipleCar=1; this.setState(() => ({multipleCar:multipleCar}),function(){this.calculateMajoration()}) }}   />}

        {(this.state.taxiMode==true && this.state.estimatePriceGo.explicationPricing.type!="forfait" && (this.state.stopList==undefined || this.state.stopList.length==0)) && <TextPresentation maxiMode={this.state.dispenser} style={{marginTop:5}} onoff={(this.state.goReturnTaxi==undefined)?false:this.state.goReturnTaxi} text={strings.goReturnTaxi} textMini={strings.goReturnTaxiMoreInfo}  onOnOff={()=>{ if(this.state.waiting==false){this.setState(() => ({goReturnTaxi:(this.state.goReturnTaxi==true)?false:true }),function(){ this.calculateMajoration(); }) } }} />}

        {(this.state.hideOption!=true && this.state.viewFlightTrain!=false) && <TextPresentation stationCoor={this.state.trainFlightCoor} raceDate={this.state.integerDate} suggestions={"train"} onSuggestion={(value)=>{ var text=value.name; text=text.replace(" ", ''); this.setState({flightTrain:text})  }} icon={(this.state.viewFlightTrain=="train")?((style.mode=="dark")?require('../assets/favorite/train_white.png'):require('../assets/favorite/train_black.png')):((style.mode=="dark")?require('../assets/favorite/flight_white.png'):require('../assets/favorite/flight_black.png'))} style={{marginTop:5}} text={this.state.flightTrain} maxiMode={this.state.dispenser} textExplication={(this.state.viewFlightTrain=="train")?strings.numeroTrain:strings.numeroFlight} placeholder={(this.state.viewFlightTrain=="train")?"65334":"AF1234"} onChangeText={(text)=>{ text=text.replace(" ", ''); this.setState({flightTrain:text}) }}/>}

        {(this.state.hideOption!=true && this.state.hideParticularRqs!=true) && <TextPresentation style={{marginTop:10 }} text={this.state.description} icon={(style.mode=="dark")?require('../assets/request_white.png'):require('../assets/request_black.png')} maxiMode={this.state.dispenser} multiline={true} reduceTextSize={true} textExplication={strings.specialRequests} placeholder={(this.state.viewFlightTrain!=false)?strings.bookDescriptionBasicEx:strings.bookDescriptionEx    } onChangeText={(text)=>{this.setState({description:text},() =>{this.saveBook() }) }}/>}

        {(((this.state.forceViewPartner===true || (info.customerChoicePartner==true && (this.state.params.data.immediate!=true || this.state.params.data.removeFavoriteDriver30==false || this.state.params.data.removeRace5minutes==false ) && ( (this.state.driver==false && this.state.partner==false) || info.disableOnBoardPayment!=true) ) ) || this.state.driver==true) && this.state.dispenser!=true) && <TextPresentation icon={(style.mode=="dark")?require('../assets/partner_light.png'):require('../assets/partner_dark.png')}  style={{marginTop:5}} maxiMode={this.state.dispenser} textExplication={((this.state.driver==true && this.state.forceDesired!=true && this.state.partnerSelected.id!=-1) || (this.state.partner==true && this.state.partnerSelected.id==getAuth(firebase).currentUser.uid) )?strings.attributedPartner: strings.desiredDriver} text={this.state.partnerSelected.text} editable={false} viewEdit={true} onEditClick={() => {if(this.state.params.data.lockOtherPartner!=true) this.viewPartner()}}
          elementRight={((getAuth(firebase).currentUser!=undefined && this.state.partnerSelected.id!=getAuth(firebase).currentUser.uid) && this.state.hideOption!=true && this.state.driver==true && this.state.taxiMode!=true)?
              <TouchableHighlight style={{alignItems:"center",justifyContent:"center"}} underlayColor={'#FFFFFF00'} onPress={() => {this.changeAmountDriver()}}>
                <View style={{flexDirection:"row", alignItems:"center",justifyContent:"center"}}>
                    <Text style={{marginLeft:2, color: style.textInputColor,fontSize: style.textInputFontSize*((this.state.forceDriverPrice==false)?0.9:2),textAlign: "right",width:120, fontWeight: 'bold'}}>{(this.state.forceDriverPrice==false)?strings.forceDriverPriceQuestion:(((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.forceDriverPriceAmount+((this.state.money.position=="right")?(this.state.money.symbole):"") )}</Text>
                    <Image source={(style.mode=="dark")?require('../assets/edit_white.png'):require('../assets/edit_black.png')} style={{height:12,width:12,marginLeft:3, resizeMode:"contain"}}/>

                </View>
              </TouchableHighlight>
           :undefined}





        />}


        {(this.state.hideOption!=true && this.state.params.data.disabledPromoCode!=true && this.state.taxiMode!=true && this.state.promo.codeID!="PERMANENT") && <TextPresentation icon={(style.mode=="dark")?require('../assets/promo_white.png'):require('../assets/promo_black.png')} maxiMode={this.state.dispenser} style={{marginTop:5}} textInputFlex={1} text={this.state.promoCode} textExplication={strings.promoCode} placeholder={"Ex : HAPPY"} onEndEditing={(text)=>{this.testPromoCode()   }}    onChangeText={(text)=>{
            if(Platform.OS=="web") timer.setTimeout("testPromoCode", () => {this.testPromoCode() }, 3000);
          this.setState({promoCode:text})}}/>}

        {(this.state.hideOption!=true && this.state.params.data.disabledPromoCode!=true && this.state.taxiMode!=true && this.state.promo.codeID=="PERMANENT") && <TextPresentation icon={(style.mode=="dark")?require('../assets/promo_white.png'):require('../assets/promo_black.png')} maxiMode={this.state.dispenser} style={{marginTop:5}} textInputFlex={1} text={this.state.promoCode} textExplication={strings.promoCode} editable={false} enableRemove={true} onRemove={() => { this.testPromoCode()  }} />}
        
        {(((getAuth(firebase).currentUser!=undefined && this.state.partnerSelected.id!=getAuth(firebase).currentUser.uid) && ((this.state.partner==true && this.state.params.data.privilegeDriver=="max" && (this.state.params.data.billMode=="double" || this.state.params.data.billMode=="partnerCompany" ) ) && this.state.driver==false) && this.state.taxiMode!=true ) && this.state.hideOption!=true) && <TextPresentation icon={(style.mode=="dark")?require('../assets/driver_bon_light.png'):require('../assets/driver_bon_dark.png')} maxiMode={this.state.dispenser} style={{marginTop:5}} text={this.state.paymentDriverModeTxt} textExplication={strings.infoBill} editable={false} viewEdit={true} onEditClick={() => {this.changeBillOptionForMaxDriver();}} />}
        

        {(this.state.hideOption!=true && this.state.driver==true && this.state.taxiMode!=true && this.state.deferredPayment!=true) && <TextPresentation textMini={strings.raceAlreadyPaidMoreInfo}  onoff={this.state.alreadyPaid} onOnOff={()=>{ this.setState({alreadyPaid:!this.state.alreadyPaid}) }}  text={strings.raceAlreadyPaid} editable={false}   />}
        {(this.state.hideOption!=true && this.state.driver==true && this.state.taxiMode!=true && this.state.alreadyPaid==true) && <TextPresentation textMini={strings.notBillMoreInfo}  onoff={this.state.notBill} onOnOff={()=>{  this.setState({notBill:!this.state.notBill}) }}  text={strings.notBill} editable={false}   />}

          
          
        {((info.disableOnBoardPayment==false || this.state.noCardDetected==false) && info.paymentCardApp===true && this.state.dispenser!=true && this.state.driver!=true && this.state.partner!=true && this.state.deferredPayment!=true && this.state.taxiMode!=true && this.state.viewAddCard!=true) && <TextPresentation  viewEdit={true} onEditClick={() => {this.viewCard();}} style={{marginTop:5}} icon={this.state.cardSelected.icon} editable={false} text={(this.state.cardSelected.load===true)?"": (this.state.cardSelected.withBancontact===true)? strings.bancontact   : ((this.state.cardSelected.withCredit===true)?strings.withCredit:(this.state.cardSelected.onBoard===true)?strings.onBoard:this.state.cardSelected.last4)} textExplication={strings.paymentMode}  /> }


          

            {(info.paymentCardApp===true && this.state.viewAddCard!=true && info.disableOnBoardPayment==false && this.state.driver!=true && this.state.dispenser!=true && this.state.partner!=true && this.state.provider!=true && this.state.deferredPayment!=true && this.state.taxiMode!=true && this.state.noCardDetected==true) && <TouchableHighlight underlayColor={'rgba(255,255,255,0)'} onPress={() => { this.setState({viewAddCard:true}) }} >
              <Text style={{marginTop:10,marginLeft:"10%", marginRight:"10%", color: style.textInputColor,fontSize: style.textInputFontSize,textAlign: "center",marginBottom:10}}>{strings.preferCard}</Text>
            </TouchableHighlight>}


            {this.state.viewAddCard==true && <AddCreditCard cancelButton={() => { this.setState({viewAddCard:false}) }}  defautVisible={true} newCardAdded={() => { this.getUserCards() }} />}

            {(info.paymentCardApp===true && info.disableOnBoardPayment==true && this.state.dispenser!=true && this.state.driver!=true && this.state.partner!=true && this.state.deferredPayment!=true && this.state.taxiMode!=true && this.state.noCardDetected==true) && 
              
               <AddCreditCard newCardAdded={() => { this.getUserCards() }} />} 

            {(info.paymentCardApp===true && info.disableOnBoardPayment==true && info.withBancontact===true && this.state.dispenser!=true && this.state.driver!=true && this.state.partner!=true && this.state.deferredPayment!=true && this.state.taxiMode!=true && this.state.noCardDetected==true) && <TouchableHighlight underlayColor={'rgba(255,255,255,0)'} onPress={() => {  this.setState({noCardDetected:false, cardSelected:this.state.cardList[this.state.cardList.length-1] })}} >
              <Text style={{marginTop:10,marginLeft:"10%", marginRight:"10%", color: style.textInputColor,fontSize: style.textInputFontSize,textAlign: "center",marginBottom:10}}>{strings.paidWithBancontact}</Text>
            </TouchableHighlight>}

            {(info.paymentCardApp===true && info.disableOnBoardPayment==true && this.state.dispenser!=true && this.state.driver!=true && this.state.partner!=true && this.state.deferredPayment!=true && this.state.taxiMode!=true && this.state.noCardDetected==true) && <TouchableHighlight underlayColor={'rgba(255,255,255,0)'} onPress={() => { this.setState({noCardDetected:false})}} >
              <Text style={{marginTop:10,marginLeft:"10%", marginRight:"10%", color: style.textInputColor,fontSize: style.textInputFontSize,textAlign: "center",marginBottom:10}}>{strings.paidWithCredit}</Text>
            </TouchableHighlight>}


            {(this.state.deferredPayment==true) && <TextPresentation style={{marginTop:5}} icon={require("../assets/check_mark.png")} editable={false} textExplication={strings.payment} text={strings.deferredPaymentRace}  />}

            {(this.state.cpam==true) && <View style={{marginTop:30,alignItems:"center", shadowColor:(style.mode=="dark")?'#000':"#FFFFFF", shadowRadius: 1,shadowOffset: {height: 0,width: 0},elevation: 1}}>
                <Image source={require("../assets/warning.png")} style={{height:50, width:50,resizeMode:"contain"}}/>
                <Text style={{color: style.colorNotification,fontSize: style.textInputFontSize*1.3,textAlign: "center", fontWeight: 'bold',}}>{strings.raceCPAM}</Text>
                <Text style={{color: style.colorNotification,marginLeft:"10%", marginRight:"10%",fontSize: style.textInputFontSize,textAlign: "center",marginBottom:10}}>{strings.raceCPAMMoreInfo}</Text>
                    


            </View>}

            {this.state.cpam!=true && <View>
                
                
              {(this.state.taxiMode!=true && (this.state.driver==true || (this.state.partner==true || (this.state.provider==true && this.state.privilegeProvider=="avance")  ) ) ) && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {

                
                this.alert.onAlert({title:strings.priceSettings,textInput:{placeholder:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"40"+((this.state.money.position=="right")?(this.state.money.symbole):""),text:this.state.estimatePriceGo.realPrice.priceTotal.toString(),sizeMultiplicator:2,detectSequencePosition:this.state.money.position,detectSequence:this.state.money.symbole,keyboardType:"numeric"},buttons:[
                    {text: strings.validate,onPress: (value) => {
                       value=value.toString().replace(this.state.money.symbole,'')
                      value=parseFloat(value);
                      var precision=(this.state.params.data.pricingPrecise===true)?100:1;
                      var valfi=Math.round(value*precision)/precision
                      var estg=this.state.estimatePriceGo;

                      if(valfi.toString()!="NaN" ){
                        estg.realPrice={avanceOrder:0,lastMinute:0, "majorationDate":{"amount": 0,"name": ""},majorationRealTime:0, priceBasic:valfi, priceTotal:valfi, "promo": {"amount": 0,} }
                        this.setState({estimatePriceGo:estg})
                      }

                      

                    }},
                    {text: strings.cancel, style:"cancel",onPress: () => {}}
                    ],})

                }}>
                    <Text allowFontScaling={false} style={{marginTop:30,color: style.textInputColor,fontSize: style.textInputFontSize*1.2*( (this.state.dispenser==true)?((Dimensions.get('window').width>1000)?3:2.3):1),textAlign: "center",}}>{strings.priceEstimation +" : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.estimatePriceGo.realPrice.priceTotal+((this.state.money.position=="right")?(this.state.money.symbole):"")}</Text>

                </TouchableHighlight>}

                {(this.state.taxiMode==true || !(this.state.driver==true || (this.state.partner==true) || (this.state.provider==true && this.state.privilegeProvider=="avance")) ) && <Text allowFontScaling={false} style={{marginTop:30,color: style.textInputColor,fontSize: style.textInputFontSize*1.2*( (this.state.dispenser==true)?((Dimensions.get('window').width>1000)?3:2.3):1),textAlign: "center",}}>{strings.priceEstimation +" : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.estimatePriceGo.realPrice.priceTotal+((this.state.money.position=="right")?(this.state.money.symbole):"") +((this.state.noVAT==true)?"HT":"") }</Text>}



                {(this.state.params.data.viewAccurency==true && convertPrice!="" && (Object.keys(this.state.params.data.viewAccurencyList).length>1 || (Object.keys(this.state.params.data.viewAccurencyList).length==1 &&  Object.keys(this.state.params.data.viewAccurencyList)[0] !=this.state.money.id       ) ) ) && <Text allowFontScaling={false} style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.65*( (this.state.dispenser==true)?((Dimensions.get('window').width>1000)?3:2.3):1),textAlign: "center",}}>{strings.equivalentTo +" : "+convertPrice}</Text>}





                {(this.state.params.data.hideMajoration!=true) && <View>

               {(this.state.estimatePriceGo.realPrice.majorationRealTime!=undefined && this.state.estimatePriceGo.realPrice.majorationRealTime!=0) && <Text allowFontScaling={false} style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.8*( (this.state.dispenser==true)?((Dimensions.get('window').width>1000)?3:2.3):1),textAlign: "center",}}>{strings.whose+" "+strings.majoTakingTraffic.toLowerCase() +" : "+ ((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.estimatePriceGo.realPrice.majorationRealTime.toFixed(2) +((this.state.money.position=="right")?(this.state.money.symbole):"")}</Text>}
               {(this.state.estimatePriceGo.realPrice.majorationDate!=undefined && this.state.estimatePriceGo.realPrice.majorationDate.amount!=0) && <Text allowFontScaling={false} style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.8*( (this.state.dispenser==true)?((Dimensions.get('window').width>1000)?3:2.3):1),textAlign: "center",}}>{strings.whose+" "+((this.state.estimatePriceGo.realPrice.majorationDate.name!="saturday")? ((this.state.estimatePriceGo.realPrice.majorationDate.name!="sunday")? (  (this.state.estimatePriceGo.realPrice.majorationDate.name!="night")? (  (this.state.estimatePriceGo.realPrice.majorationDate.name!="ferie")? ( (this.state.estimatePriceGo.realPrice.majorationDate.name!="morning")? ( (this.state.estimatePriceGo.realPrice.majorationDate.name!="evening")? ( (this.state.estimatePriceGo.realPrice.majorationDate.name!="dynamic")? ((this.state.estimatePriceGo.realPrice.majorationDate.name!="completeNight")? ( (this.state.estimatePriceGo.realPrice.majorationDate.name!="afternoon")? ( (this.state.estimatePriceGo.realPrice.majorationDate.name=="highAffluence")? strings.majoHighAffluence.toLowerCase() : (  (this.state.estimatePriceGo.realPrice.majorationDate.name=="majoOther")?strings.majoHourFrequency:   strings.majoAllPassagers.toLowerCase() ) ) :  ((this.state.hideHoursMajoration==true)?strings.majoHourFrequency.toLowerCase():  strings.majoAfternoon.toLowerCase() )       )  : ((this.state.hideHoursMajoration==true)?strings.majoHourFrequency.toLowerCase():strings.majoNight.toLowerCase() )  )  : strings.majoDynamic.toLowerCase()   )  : ((this.state.hideHoursMajoration==true)?strings.majoHourFrequency.toLowerCase():strings.majoEvening.toLowerCase() )  )  : ((this.state.hideHoursMajoration==true)?strings.majoHourFrequency.toLowerCase():strings.majoMorning.toLowerCase()) ) : strings.majoFerie.toLowerCase()     ) : ((this.state.hideHoursMajoration==true)?strings.majoHourFrequency.toLowerCase():strings.majoNight.toLowerCase() )  ) : strings.majoSunday.toLowerCase() ):strings.majoSaturday.toLowerCase()  ) +" : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.estimatePriceGo.realPrice.majorationDate.amount.toFixed(2)+((this.state.money.position=="right")?(this.state.money.symbole):"") }</Text>}
               {(this.state.estimatePriceGo.realPrice.majorationPassagers!=undefined && this.state.estimatePriceGo.realPrice.majorationPassagers!=0) && <Text allowFontScaling={false} style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.8*( (this.state.dispenser==true)?((Dimensions.get('window').width>1000)?3:2.3):1),textAlign: "center",}}>{strings.whose+" "+strings.majoAllPassagers.toLowerCase() +" : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.estimatePriceGo.realPrice.majorationPassagers.toFixed(2)+((this.state.money.position=="right")?(this.state.money.symbole):"")}</Text>}
               

               {(this.state.estimatePriceGo.realPrice.majorationAdvance!=undefined && this.state.estimatePriceGo.realPrice.majorationAdvance!=0) && <Text allowFontScaling={false} style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.8*( (this.state.dispenser==true)?((Dimensions.get('window').width>1000)?3:2.3):1),textAlign: "center",}}>{strings.whose+" "+strings.majoChildSeats.toLowerCase() +" : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.estimatePriceGo.realPrice.majorationAdvance.toFixed(2)+((this.state.money.position=="right")?(this.state.money.symbole):"")}</Text>}

                  

               </View>}



               {(this.state.estimatePriceGo.realPrice.promo!=undefined && this.state.estimatePriceGo.realPrice.promo.amount!=0) && <Text allowFontScaling={false} style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.8*( (this.state.dispenser==true)?((Dimensions.get('window').width>1000)?3:2.3):1),textAlign: "center",}}>{strings.promoCode+" "+this.state.estimatePriceGo.realPrice.promo.name + ((this.state.estimatePriceGo.realPrice.promo.percent>0)?" ("+(this.state.estimatePriceGo.realPrice.promo.percent*100)+"%)" :"")   +" : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.estimatePriceGo.realPrice.promo.amount+((this.state.money.position=="right")?(this.state.money.symbole):"")}</Text>}
                {this.state.taxiMode==true && <Text allowFontScaling={false} style={{marginTop:10,color: style.textInputColor,fontSize: style.textInputFontSize*0.8*( (this.state.dispenser==true)?((Dimensions.get('window').width>1000)?3:2.3):1),textAlign: "center",}}>{strings.warningPriceTaxi}</Text>}

               {this.state.endAddress=="" && <Text allowFontScaling={false} style={{marginTop:10,color: style.textInputColor,fontSize: style.textInputFontSize*( (this.state.dispenser==true)?((Dimensions.get('window').width>1000)?3:2.3):1),textAlign: "center", marginLeft:"10%", marginRight:"10%"}}>{strings.kmLimit+((this.state.kmLimit!="")?" ("+this.state.kmLimit+strings.km+")":"")}</Text>}
               {(this.state.params.data.customerMessageFreeCancel!=false && this.state.params.data.immediate!=true) && <Text allowFontScaling={false} style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.65*( (this.state.dispenser==true)?((Dimensions.get('window').width>1000)?3:2.3):1),textAlign: "center", marginLeft:"10%", marginRight:"10%"}}>{strings.freeCancelAnnulation1+" "+this.state.params.data.customerMessageFreeCancel+" "+strings.freeCancelAnnulation2.toLowerCase() }</Text>}
               {(this.state.params.data.messageBeforeBook!=false && this.state.params.data.messageBeforeBook[strings.idLangue]!=undefined) && <Text allowFontScaling={false} style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.65*( (this.state.dispenser==true)?((Dimensions.get('window').width>1000)?3:2.3):1),textAlign: "center", marginLeft:"10%", marginRight:"10%"}}>{this.state.params.data.messageBeforeBook[strings.idLangue]}</Text>}


              
               



                


              </View>}

              {(this.state.waitingPromo==true || this.state.waitingPartnerList==true || this.state.waitingUserCard==true) && <ActivityIndicator style={{marginTop:30}} size="large" color={style.color1} />}
              

              {(this.state.waitingPromo==false && this.state.waitingPartnerList==false && this.state.waitingUserCard==false  && !((this.state.driver==true || this.state.partner==true) &&  (info.disableOnBoardPayment==true && this.state.driver!=true) && (this.state.partnerSelected.id!=getAuth(firebase).currentUser.uid) && this.state.alreadyPaid!=true) ) && <View style={{alignItems:"center",justifyContent:"center",marginTop:30, marginBottom:30}}>
                    <MavButton maxiMode={this.state.dispenser} text={strings.validate} onlyButton={true} onPress={()=>{ 
                    if( !(this.state.date.length > 0)) this.alert.onAlert({title:strings.thanksSelectDate}) ;
                    else if( (this.state.driver==true || this.state.partner==true || this.state.provider==true) && this.state.lastName==""   ) this.alert.onAlert({title:strings.thankWriteName}) ;
                    else if(this.state.dispenser==true && this.state.phone=="") this.alert.onAlert({title:strings.incorrectPhoneNumber})  
                    else if(this.state.passagerNumber>this.state.passagers && this.state.passagers!=0) this.alert.onAlert({title:strings.incorrectPassagers}) 
                    
                    else if(info.myPos==true) this.sendBooking("myPos");
                    else if(this.state.cardSelected.withBancontact===true) this.sendBooking("bancontact");
                    else this.sendBooking();
                  }}/>
                </View>}



              {(this.state.taxiMode!=true && info.stripePublicKey!=undefined && info.stripePublicKey!="" && info.paymentCardApp===true && this.state.driver==true && this.state.waitingPromo==false && this.state.waitingPartnerList==false && this.state.waitingUserCard==false && this.state.alreadyPaid!=true) && <View style={{alignItems:"center",justifyContent:"center", marginBottom:30}}>
                    <MavButton maxiMode={this.state.dispenser} text={strings.validateAfterPayment} onlyButton={true} onPress={()=>{ 
                    if( !(this.state.date.length > 0)) this.alert.onAlert({title:strings.thanksSelectDate}) ;
                    else if( (this.state.driver==true || this.state.partner==true || this.state.provider==true) && this.state.lastName==""   ) this.alert.onAlert({title:strings.thankWriteName}) ;
                    else if(this.state.dispenser==true && this.state.phone=="") this.alert.onAlert({title:strings.incorrectPhoneNumber}) 
                    else if(this.state.passagerNumber>this.state.passagers) this.alert.onAlert({title:strings.incorrectPassagers})  
                    else this.sendBooking("linkPayment");
                  }}/>
                </View>}

              {(this.state.waitingPromo==false && this.state.cpam!=true && info.disableOnBoardPayment!=true && this.state.waitingPartnerList==false && this.state.waitingUserCard==false  &&  this.state.driver==true && this.state.alreadyPaid!=true && this.state.cpam!=true  ) && <View style={{alignItems:"center",justifyContent:"center", marginBottom:30}}>
                  <MavButton maxiMode={this.state.dispenser} text={strings.validateAfterQuotation} onlyButton={true} onPress={()=>{ 
                  
                    var emailOK=false;
                    if(this.state.email!=undefined && this.state.email!=""){
                      let reg = /[a-z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,8}$/;
                      if(reg.test(this.state.email) === true) emailOK=true
                    }
                    if( (this.state.driver==true || this.state.partner==true || this.state.provider==true) && this.state.lastName=="" ) this.alert.onAlert({title:strings.thankWriteName}) ;
                    else if(this.state.passagerNumber>this.state.passagers) this.alert.onAlert({title:strings.incorrectPassagers}) 
                    else if(emailOK==false) this.alert.onAlert({title:strings.emailToQuotation}) ;
                    else this.sendBooking("quotation");
                }}/>
              </View>}


              {(this.state.waitingPromo==false && this.state.cpam!=true &&  info.disableOnBoardPayment==true && this.state.waitingPartnerList==false && this.state.waitingUserCard==false  &&  this.state.driver==true  ) && <View style={{alignItems:"center",justifyContent:"center", marginBottom:30}}>
                  <MavButton maxiMode={this.state.dispenser} text={strings.validateAfterQuotation} onlyButton={true} onPress={()=>{ 
                  
                    var emailOK=false;
                    if(this.state.email!=undefined && this.state.email!=""){
                      let reg = /[a-z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,8}$/;
                      if(reg.test(this.state.email) === true) emailOK=true
                    }
                    if( (this.state.driver==true || this.state.partner==true || this.state.provider==true) && this.state.lastName=="" ) this.alert.onAlert({title:strings.thankWriteName}) ;
                    else if(this.state.passagerNumber>this.state.passagers) this.alert.onAlert({title:strings.incorrectPassagers}) 
                    else if(emailOK==false) this.alert.onAlert({title:strings.emailToQuotation}) ;
                    else {


                    var list="<html xmlns=\'http://www.w3.org/1999/xhtml\' xmlns:v=\'urn:schemas-microsoft-com:vml\' xmlns:o=\'urn:schemas-microsoft-com:office:office\'><head>  <title></title>  <!--[if !mso]><!-- -->  <meta http-equiv=\'X-UA-Compatible\' content=\'IE=edge\'>  <!--<![endif]--><meta http-equiv=\'Content-Type\' content=\'text/html; charset=UTF-8\'><meta name=\'viewport\' content=\'width=device-width, initial-scale=1.0\'><style type=\'text/css\'>  #outlook a { padding: 0; }  .ReadMsgBody { width: 100%; }  .ExternalClass { width: 100%; }  .ExternalClass * { line-height:100%; }  body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }  table, td { border-collapse:collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }  img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }  p { display: block; margin: 13px 0; }</style><!--[if !mso]><!--><style type=\'text/css\'>  @media only screen and (max-width:480px) {    @-ms-viewport { width:320px; }    @viewport { width:320px; }  }</style><!--<![endif]--><!--[if mso]><xml>  <o:OfficeDocumentSettings>    <o:AllowPNG/>    <o:PixelsPerInch>96</o:PixelsPerInch>  </o:OfficeDocumentSettings></xml><![endif]--><!--[if lte mso 11]><style type=\'text/css\'>  .outlook-group-fix {    width:100% !important;  }</style><![endif]--><style type=\'text/css\'>  @media only screen and (min-width:480px) {    .mj-column-per-100 { width:100%!important; }  }</style></head><body style=\'background: #efefefef;\'>    <div class=\'mj-container\' style=\'background-color:#efefefef;\'> <div style=\'margin:0px auto;max-width:600px;background:"+style.color1+";\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;background:"+style.color1+";\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 20px 0px 20px;\' align=\'center\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:center;\'><h1 style=\'font-family: Helvetica, sans-serif; color: #FFFFFF; font-size: 26px; line-height: 100%;\'>VOTRE DEVIS</h1></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><div style=\'margin:0px auto;max-width:600px;background:#FFFFFF;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;background:#FFFFFF;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:center;\'><p>Vous trouverez votre devis ci-dessous. Nous vous remercions pour votre confiance</p></div><tr><td style=\'word-wrap:break-word;font-size:0px;padding:10px 25px;padding-top:17px;padding-bottom:17px;padding-right:30px;padding-left:30px;\'><p style=\'font-size:1px;margin:0px auto;border-top:1px dotted #929292;width:100%;\'></p><!--[if mso | IE]><table role=\'presentation\' align=\'center\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:1px;margin:0px auto;border-top:1px dotted #929292;width:100%;\' width=\'600\'><tr><td style=\'height:0;line-height:0;\'>&nbsp;</td></tr></table><![endif]--></td></tr><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 25px 0px 25px;\' align=\'left\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:left;\'><h2 style=\'font-family: Helvetica, sans-serif; line-height: 100%;\'>"+((this.state.endAddress=="")?"VOTRE MISE A DISPOSITION":"VOTRE TRAJET")+"</h2><p><strong>Départ </strong>: "+this.state.startAddress+"</p>"+((this.state.endAddress!="")?"<p><strong>Arrivée </strong>: "+this.state.endAddress+"</p>":"")+"<p><strong>Jour &amp; heure </strong>: "+this.state.date+"</p><p><strong>Durée </strong>: "+(((Math.floor(this.state.estimateTime/3600))<10)?"0":"")+Math.floor(this.state.estimateTime/3600)+":"+((Math.floor((this.state.estimateTime%3600)/60)<10)?"0":"")+Math.floor((this.state.estimateTime%3600)/60)+"</p>"+((this.state.endAddress!="")?"<p><strong>Km </strong>: "+this.state.estimateKm+"</p>":"")+"<p><strong>Véhicule </strong>: "+this.state.carName+"</p><p><strong>Prix </strong>: "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+this.state.estimatePriceGo.realPrice.priceTotal+((this.state.money.position=="right")?(this.state.money.symbole):"")+"</p></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;background:#FFFFFF;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 25px 0px 25px;\' align=\'center\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:center;\'><p></p></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></table><!--[if mso | IE]>      </td></tr></table>      <![endif]--><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;\'><div style=\'font-size:1px;line-height:50px;white-space:nowrap;\'>&nbsp;</div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'background:#333333;font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;\'><div style=\'font-size:1px;line-height:50px;white-space:nowrap;\'>&nbsp;</div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'background:#333333;font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 20px 0px 20px;\' align=\'center\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:11px;line-height:22px;text-align:center;\'><p><span style=\'color:#ffffff;\'>"+this.state.companyBrand+" | "+this.state.companyAdress+" | "+this.state.companyCity+" | "+this.state.companyPhone+" | "+this.state.companyEmail+"</span></p></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>      </td></tr></table>      <![endif]--></div></body></html>"                                                                                                                                                                            
                    getAuth(firebase).currentUser.getIdToken().then(token => {

                      var bodyInfo={
                          toEmail:this.state.email,
                          toName:this.state.name+" "+this.state.lastName, 
                          subject:"Votre devis", 
                          HTMLPart:list, 
                          replyToEmail:info.companyEmail,
                          replyToName:info.companyBrand,
                          token:token,

                          fromEmail:info.mavEmail,
                          fromName:info.companyBrand,
                          userID:getAuth(firebase).currentUser.uid,
                      }
                      this.firebaseSendByMail(bodyInfo)
                      this.state.params.updateAfterBook()
                      this.state.params.popToTop();

                    })
                  }

                }}/>
              </View>}

                    


             


             



              <View style={{height:20, width:20}}/>




        <Modal animationType="slide" transparent={false} visible={this.state.waiting===true}><View>

            {this.state.urlRedirect!=undefined && <View style={{height:Dimensions.get('window').height*0.8,width:Dimensions.get('window').width*0.8,marginTop:Dimensions.get('window').height*0.1,marginLeft:Dimensions.get('window').width*0.1,}}>
                <WebView style={{width:"100%", height:'100%', }} source={{ uri: this.state.urlRedirect }} 
                setSupportMultipleWindows={false}
                 onShouldStartLoadWithRequest={({ nativeEvent }) => {
                  console.log("nativeEvent lolilol")
                  console.log(nativeEvent.url); 
                  if(nativeEvent.url.search("http://www.mon-appli-vtc.com/stripeURL")!=-1) {console.log("mav !!!!"); 
                      this.setState({waiting:false}); 
                      var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params; 
                      params.popToTop(); 

                      /*
                      this.alert.onAlert({check:true, title:strings.paymentValidate, subTitle:strings.thanksWeWillReceiveAnConfirmationEmail,  buttons:[{text:strings.ok,onPress: () => {
                        var params=(this.props.navigation!=undefined)?this.props.navigation:this.props.params; 
                        params.popToTop(); 
                        this.state.params.updateAfterBook() 
                        if(this.state.params.data.immediate!=true && this.state.taxiMode!=true && this.state.purposeReturn===true && this.state.purposeReturnAlready!=true)  
                          this.state.params.purposeReturn();    
                           }}],});

                        */


                  }
                 }}/></View>}


            {this.state.urlRedirect==undefined && <View style={{alignItems:"center",justifyContent:"center",position: 'absolute',height:Dimensions.get('window').height, width:Dimensions.get('window').width,backgroundColor:style.backgroundColor}}> 
                <ActivityIndicator style={{marginTop:-100}} size="large" color={style.color1} /> 
                <Text allowFontScaling={false} style={{fontSize:style.textInputFontSize,marginTop:5,color:style.textInputColor}}>{strings.thankWaiting}</Text>
            </View>}

          </View>
        </Modal>


        <MavQRCode ref={qrCode => {this.qrCode = qrCode;}} />


        <MavAlert ref={alert => {this.alert = alert;}}/>
        


      </KeyboardAwareScrollView>

      </View>

      }</StyleContext.Consumer>
    );
  }
}




export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}
